import { getLSLanguage } from "../generic-functions/Storage";

const cities = [
  {
    city_name: "אבו ג'ווייעד (שבט)",
    city_name_arabic: "أبو جويعد",
  },
  {
    city_name: "אבו גוש",
    city_name_arabic: "أبو غوش",
  },
  {
    city_name: "אבו סנאן",
    city_name_arabic: "أبو سنان",
  },
  {
    city_name: "אבו סריחאן (שבט)",
    city_name_arabic: "Abu Sureihan",
  },
  {
    city_name: "אבו עבדון (שבט)",
    city_name_arabic: "Abu Abdun",
  },
  {
    city_name: "אבו עמאר (שבט)",
    city_name_arabic: "Abu Amar",
  },
  {
    city_name: "אבו עמרה (שבט)",
    city_name_arabic: "Abu Amre",
  },
  {
    city_name: "אבו קורינאת (שבט)",
    city_name_arabic: "أبو قرينات",
  },
  {
    city_name: "אבו קרינאת (יישוב)",
    city_name_arabic: "أبو قرينات",
  },
  {
    city_name: "אבו רובייעה (שבט)",
    city_name_arabic: "Abu Rubei'a",
  },
  {
    city_name: "אבו רוקייק (שבט)",
    city_name_arabic: "Abu Ruqayyeq",
  },
  {
    city_name: "אבו תלול",
    city_name_arabic: "Abu Tulul",
  },
  {
    city_name: "אבטין",
    city_name_arabic: "إبطن",
  },
  {
    city_name: "אבטליון",
    city_name_arabic: "أڤتليون",
  },
  {
    city_name: "אביאל",
    city_name_arabic: "أڤيئيل",
  },
  {
    city_name: "אביבים",
    city_name_arabic: "أڤيڤيم",
  },
  {
    city_name: "אביגדור",
    city_name_arabic: "أڤيچدور",
  },
  {
    city_name: "אביחיל",
    city_name_arabic: "أڤيحايل",
  },
  {
    city_name: "אביטל",
    city_name_arabic: "أڤيتال",
  },
  {
    city_name: "אביעזר",
    city_name_arabic: "أڤيعير",
  },
  {
    city_name: "אבירים",
    city_name_arabic: "أبيريم",
  },
  {
    city_name: "אבן יהודה",
    city_name_arabic: "إيڤن يهودا",
  },
  {
    city_name: "אבן מנחם",
    city_name_arabic: "إيڤن منحيم",
  },
  {
    city_name: "אבן ספיר",
    city_name_arabic: "إيڤن سپير",
  },
  {
    city_name: "אבן שמואל",
    city_name_arabic: "إيڤن شموئيل",
  },
  {
    city_name: "אבני איתן",
    city_name_arabic: "أڤني إيتان",
  },
  {
    city_name: "אבני חפץ",
    city_name_arabic: "أڤني حي فت س",
  },
  {
    city_name: "אבנת",
    city_name_arabic: "أڤنات",
  },
  {
    city_name: "אבשלום",
    city_name_arabic: "أڤشَلوم",
  },
  {
    city_name: "אדורה",
    city_name_arabic: "أدورا",
  },
  {
    city_name: "אדירים",
    city_name_arabic: "أديريم",
  },
  {
    city_name: "אדמית",
    city_name_arabic: "أَدميت",
  },
  {
    city_name: "אדרת",
    city_name_arabic: "أديرت",
  },
  {
    city_name: "אודים",
    city_name_arabic: "أوديم",
  },
  {
    city_name: "אודם",
    city_name_arabic: "أدام",
  },
  {
    city_name: "אוהד",
    city_name_arabic: "أو َهد",
  },
  {
    city_name: "אום אל-פחם",
    city_name_arabic: "أم الفحم",
  },
  {
    city_name: "אום אל-קוטוף",
    city_name_arabic: "أم القطف",
  },
  {
    city_name: "אום בטין",
    city_name_arabic: "أم بطين",
  },
  {
    city_name: "אומן",
    city_name_arabic: "أومان",
  },
  {
    city_name: "אומץ",
    city_name_arabic: "أو مت س",
  },
  {
    city_name: "אופקים",
    city_name_arabic: "أفَكيم",
  },
  {
    city_name: "אור הגנוז",
    city_name_arabic: "اور هچنوز",
  },
  {
    city_name: "אור הנר",
    city_name_arabic: " اور هنير",
  },
  {
    city_name: "אור יהודה",
    city_name_arabic: "اور يهودا",
  },
  {
    city_name: "אור עקיבא",
    city_name_arabic: "اور َعكيڤا",
  },
  {
    city_name: "אורה",
    city_name_arabic: "اورا",
  },
  {
    city_name: "אורות",
    city_name_arabic: "أوروت",
  },
  {
    city_name: "אורטל",
    city_name_arabic: "اورتال",
  },
  {
    city_name: "אורים",
    city_name_arabic: "اوريم",
  },
  {
    city_name: "אורנים",
    city_name_arabic: "رنيم",
  },
  {
    city_name: "אורנית",
    city_name_arabic: "رنيتا",
  },
  {
    city_name: "אושה",
    city_name_arabic: "أوشا",
  },
  {
    city_name: "אזור",
    city_name_arabic: "أزور",
  },
  {
    city_name: "אחווה",
    city_name_arabic: "أحڤا",
  },
  {
    city_name: "אחוזם",
    city_name_arabic: "أحو َزم",
  },
  {
    city_name: "אחוזת ברק",
    city_name_arabic: "أ حزات بَراك",
  },
  {
    city_name: "אחיהוד",
    city_name_arabic: "أحيهود",
  },
  {
    city_name: "אחיטוב",
    city_name_arabic: "أحيتوڤ",
  },
  {
    city_name: "אחיסמך",
    city_name_arabic: "أحي َسماخ",
  },
  {
    city_name: "אחיעזר",
    city_name_arabic: "أحيعيزر",
  },
  {
    city_name: "אטרש (שבט)",
    city_name_arabic: "Atrash",
  },
  {
    city_name: "איבים",
    city_name_arabic: "إبطن",
  },
  {
    city_name: "אייל",
    city_name_arabic: "إيال",
  },
  {
    city_name: "איילת השחר",
    city_name_arabic: "أييلت هشاح",
  },
  {
    city_name: "אילון",
    city_name_arabic: "أيَلون",
  },
  {
    city_name: "אילות",
    city_name_arabic: "إيلوت",
  },
  {
    city_name: "אילניה",
    city_name_arabic: " إيلَنيا",
  },
  {
    city_name: "אילת",
    city_name_arabic: "إيالت",
  },
  {
    city_name: "אירוס",
    city_name_arabic: "Irus",
  },
  {
    city_name: "איתמר",
    city_name_arabic: " إيتَ مار",
  },
  {
    city_name: "איתן",
    city_name_arabic: "إيتان",
  },
  {
    city_name: "איתנים",
    city_name_arabic: "إيَتنيم",
  },
  {
    city_name: "אכסאל",
    city_name_arabic: "إكسال",
  },
  {
    city_name: "אל סייד",
    city_name_arabic: "السيد",
  },
  {
    city_name: "אל-עזי",
    city_name_arabic: "العزي",
  },
  {
    city_name: "אל-עריאן",
    city_name_arabic: "العريان",
  },
  {
    city_name: "אל-רום",
    city_name_arabic: "ايل روم",
  },
  {
    city_name: "אלומה",
    city_name_arabic: "ألما",
  },
  {
    city_name: "אלומות",
    city_name_arabic: "ألموت",
  },
  {
    city_name: "אלון הגליל",
    city_name_arabic: "ألون ه َچليل",
  },
  {
    city_name: "אלון מורה",
    city_name_arabic: "ألون موري",
  },
  {
    city_name: "אלון שבות",
    city_name_arabic: "ألون شڤوت",
  },
  {
    city_name: "אלוני אבא",
    city_name_arabic: "ألوني أبا",
  },
  {
    city_name: "אלוני הבשן",
    city_name_arabic: "ألوني هبَشان",
  },
  {
    city_name: "אלוני יצחק",
    city_name_arabic: "ألوني يسحاك ت",
  },
  {
    city_name: "אלונים",
    city_name_arabic: "ألونيم",
  },
  {
    city_name: "אלי-עד",
    city_name_arabic: "إلي عاد",
  },
  {
    city_name: "אליאב",
    city_name_arabic: "Eliav",
  },
  {
    city_name: "אליכין",
    city_name_arabic: "إليَخين",
  },
  {
    city_name: "אליפז",
    city_name_arabic: "إليفاز",
  },
  {
    city_name: "אליפלט",
    city_name_arabic: " إليفيلت",
  },
  {
    city_name: "אליקים",
    city_name_arabic: "إليَكيم",
  },
  {
    city_name: "אלישיב",
    city_name_arabic: "إليَشيڤ",
  },
  {
    city_name: "אלישמע",
    city_name_arabic: "إليَشماع",
  },
  {
    city_name: "אלמגור",
    city_name_arabic: "َمچور",
  },
  {
    city_name: "אלמוג",
    city_name_arabic: "ألمچ",
  },
  {
    city_name: "אלעד",
    city_name_arabic: "إلعاد",
  },
  {
    city_name: "אלעזר",
    city_name_arabic: "إلعَزار",
  },
  {
    city_name: "אלפי מנשה",
    city_name_arabic: "ألفي منَشي",
  },
  {
    city_name: "אלקוש",
    city_name_arabic: "ألقوش",
  },
  {
    city_name: "אלקנה",
    city_name_arabic: "إل َكنا",
  },
  {
    city_name: "אמונים",
    city_name_arabic: "إمونيم",
  },
  {
    city_name: "אמירים",
    city_name_arabic: "أميريم",
  },
  {
    city_name: "אמנון",
    city_name_arabic: "أمنون",
  },
  {
    city_name: "אמציה",
    city_name_arabic: "أ َمتسيا",
  },
  {
    city_name: "אניעם",
    city_name_arabic: "أنيعام",
  },
  {
    city_name: "אסד (שבט)",
    city_name_arabic: "Asad",
  },
  {
    city_name: "אספר",
    city_name_arabic: "أسفار",
  },
  {
    city_name: "אעבלין",
    city_name_arabic: "إعبلين",
  },
  {
    city_name: "אעצם (שבט)",
    city_name_arabic: " sam'A",
  },
  {
    city_name: "אפיניש (שבט)",
    city_name_arabic: "Afeinish",
  },
  {
    city_name: "אפיק",
    city_name_arabic: "أفيك",
  },
  {
    city_name: "אפיקים",
    city_name_arabic: "أفيكيم",
  },
  {
    city_name: "אפק",
    city_name_arabic: "أفيك",
  },
  {
    city_name: "אפרת",
    city_name_arabic: "إفراتا",
  },
  {
    city_name: "ארבל",
    city_name_arabic: "أربيل",
  },
  {
    city_name: "ארגמן",
    city_name_arabic: "أرچمان",
  },
  {
    city_name: "ארז",
    city_name_arabic: "إيرز",
  },
  {
    city_name: "אריאל",
    city_name_arabic: "أريئيل",
  },
  {
    city_name: "ארסוף",
    city_name_arabic: "أرسوف",
  },
  {
    city_name: "אשבול",
    city_name_arabic: "إشبول",
  },
  {
    city_name: "אשבל",
    city_name_arabic: "إشبال",
  },
  {
    city_name: "אשדוד",
    city_name_arabic: "أشدود",
  },
  {
    city_name: "אשדות יעקב (איחוד)",
    city_name_arabic: "( أشدوت يعَكوڤ (إيحود",
  },
  {
    city_name: "אשדות יעקב (מאוחד)",
    city_name_arabic: "أشدوت يعَكوڤ (مؤحاد)",
  },
  {
    city_name: "אשחר",
    city_name_arabic: "إشحار",
  },
  {
    city_name: "אשכולות",
    city_name_arabic: "إشكولوت  ",
  },
  {
    city_name: "אשל הנשיא",
    city_name_arabic: "يشل هنسي",
  },
  {
    city_name: "אשלים",
    city_name_arabic: "أشَليم",
  },
  {
    city_name: "אשקלון",
    city_name_arabic: "أشكلون",
  },
  {
    city_name: "אשרת",
    city_name_arabic: "أشرات",
  },
  {
    city_name: "אשתאול",
    city_name_arabic: "إشتَ ؤول",
  },
  {
    city_name: "אתגר",
    city_name_arabic: "Etgar",
  },
  {
    city_name: "באקה אל-גרביה",
    city_name_arabic: "باقة الغربية",
  },
  {
    city_name: "באר אורה",
    city_name_arabic: "أورا ئير ",
  },
  {
    city_name: "באר גנים",
    city_name_arabic: "Be'er Ganim",
  },
  {
    city_name: "באר טוביה",
    city_name_arabic: "بئير توڤيا",
  },
  {
    city_name: "באר יעקב",
    city_name_arabic: "بئير كوڤَيع",
  },
  {
    city_name: "באר מילכה",
    city_name_arabic: "بئير ملكا",
  },
  {
    city_name: "באר שבע",
    city_name_arabic: "بئير شيعَڤ",
  },
  {
    city_name: "בארות יצחק",
    city_name_arabic: "بئروت يتسحاك",
  },
  {
    city_name: "בארותיים",
    city_name_arabic: "بمئروتاي",
  },
  {
    city_name: "בארי",
    city_name_arabic: "بئري",
  },
  {
    city_name: "בוסתן הגליל",
    city_name_arabic: "ب ستان ه َچليل",
  },
  {
    city_name: "בועיינה-נוג'ידאת",
    city_name_arabic: "بعينة–نجيدات",
  },
  {
    city_name: "בוקעאתא",
    city_name_arabic: "بقعاتة",
  },
  {
    city_name: "בורגתה",
    city_name_arabic: "Burgeta",
  },
  {
    city_name: "בחן",
    city_name_arabic: "با َحن",
  },
  {
    city_name: "בטחה",
    city_name_arabic: "بتحا",
  },
  {
    city_name: "ביצרון",
    city_name_arabic: "بت َسرون",
  },
  {
    city_name: "ביר אל-מכסור",
    city_name_arabic: "بئر المكسور",
  },
  {
    city_name: "ביר הדאג'",
    city_name_arabic: "بئر هداج",
  },
  {
    city_name: "ביריה",
    city_name_arabic: "بيريا",
  },
  {
    city_name: "בית אורן",
    city_name_arabic: "بيت أورن",
  },
  {
    city_name: "בית אל",
    city_name_arabic: "بيت إيل",
  },
  {
    city_name: "בית אלעזרי",
    city_name_arabic: "بيت إل َعزري",
  },
  {
    city_name: "בית אלפא",
    city_name_arabic: "بيت ألفا",
  },
  {
    city_name: "בית אריה",
    city_name_arabic: "بيت أريي",
  },
  {
    city_name: "בית ברל",
    city_name_arabic: "بيت بيرل",
  },
  {
    city_name: "בית ג'ן",
    city_name_arabic: "بيت جن",
  },
  {
    city_name: "בית גוברין",
    city_name_arabic: "بيت چڤرين",
  },
  {
    city_name: "בית גמליאל",
    city_name_arabic: "بيت چمليئيل",
  },
  {
    city_name: "בית דגן",
    city_name_arabic: "بيت َدچان",
  },
  {
    city_name: "בית הגדי",
    city_name_arabic: "بيت َه َچدي",
  },
  {
    city_name: "בית הלוי",
    city_name_arabic: "بيت هلڤي",
  },
  {
    city_name: "בית הלל",
    city_name_arabic: "بيت هليل",
  },
  {
    city_name: "בית העמק",
    city_name_arabic: "بيت َهعيمك",
  },
  {
    city_name: "בית הערבה",
    city_name_arabic: "بيت َه َعرڤا",
  },
  {
    city_name: "בית השיטה",
    city_name_arabic: "بيت هشِتا",
  },
  {
    city_name: "בית זיד",
    city_name_arabic: "بيت زايد",
  },
  {
    city_name: "בית זית",
    city_name_arabic: "بيت زايت",
  },
  {
    city_name: "בית זרע",
    city_name_arabic: "بيت زي َرع",
  },
  {
    city_name: "בית חורון",
    city_name_arabic: "بيت حورون",
  },
  {
    city_name: "בית חירות",
    city_name_arabic: "بيت حروت",
  },
  {
    city_name: "בית חלקיה",
    city_name_arabic: "بيت حلكيا",
  },
  {
    city_name: "בית חנן",
    city_name_arabic: "بيت َحنان",
  },
  {
    city_name: "בית חנניה",
    city_name_arabic: "بيت حننيا",
  },
  {
    city_name: "בית חשמונאי",
    city_name_arabic: "بيت َحشموناي",
  },
  {
    city_name: "בית יהושע",
    city_name_arabic: "بيت يهوشو َوع",
  },
  {
    city_name: "בית יוסף",
    city_name_arabic: "بيت يوسيف",
  },
  {
    city_name: "בית ינאי",
    city_name_arabic: "بيت َيناي",
  },
  {
    city_name: "בית יצחק-שער חפר",
    city_name_arabic: "بيت يتسحاك – شا َعر حيفر",
  },
  {
    city_name: "בית לחם הגלילית",
    city_name_arabic: "بيت ليحم هچليليت",
  },
  {
    city_name: "בית מאיר",
    city_name_arabic: "بيت مئير",
  },
  {
    city_name: "בית נחמיה",
    city_name_arabic: "بيت نحميا",
  },
  {
    city_name: "בית ניר",
    city_name_arabic: "بيت نير",
  },
  {
    city_name: "בית נקופה",
    city_name_arabic: "بيت نكوفا",
  },
  {
    city_name: "בית עובד",
    city_name_arabic: "بيت عوڤيد",
  },
  {
    city_name: "בית עוזיאל",
    city_name_arabic: "بيت عزيئيل",
  },
  {
    city_name: "בית עזרא",
    city_name_arabic: "بيت عزرا",
  },
  {
    city_name: "בית עריף",
    city_name_arabic: "بيت َعريف",
  },
  {
    city_name: "בית צבי",
    city_name_arabic: "بيت تسڤي",
  },
  {
    city_name: "בית קמה",
    city_name_arabic: "بيت كما",
  },
  {
    city_name: "בית קשת",
    city_name_arabic: "بيت كيشت",
  },
  {
    city_name: "בית רבן",
    city_name_arabic: "بيت َربان",
  },
  {
    city_name: "בית רימון",
    city_name_arabic: "بيت رمون",
  },
  {
    city_name: "בית שאן",
    city_name_arabic: "بيت شآن",
  },
  {
    city_name: "בית שמש",
    city_name_arabic: "بيت شيمش",
  },
  {
    city_name: "בית שערים",
    city_name_arabic: "بيت ش َعريم",
  },
  {
    city_name: "בית שקמה",
    city_name_arabic: "بيت شكما",
  },
  {
    city_name: "ביתן אהרן",
    city_name_arabic: "بيتان أ َهرون",
  },
  {
    city_name: "ביתר עילית",
    city_name_arabic: "بيتار عليت",
  },
  {
    city_name: "בלפוריה",
    city_name_arabic: "بلفوريا",
  },
  {
    city_name: "בן זכאי",
    city_name_arabic: "بين زكاي",
  },
  {
    city_name: "בן עמי",
    city_name_arabic: "بين عمي",
  },
  {
    city_name: "בן שמן (כפר נוער)",
    city_name_arabic: "بين شيمن (قرية شبيبة)",
  },
  {
    city_name: "בן שמן (מושב)",
    city_name_arabic: "بين شيمن (موشاڤ)",
  },
  {
    city_name: "בני ברק",
    city_name_arabic: "بني براك",
  },
  {
    city_name: "בני דקלים",
    city_name_arabic: "Bne Dekalim",
  },
  {
    city_name: "בני דרום",
    city_name_arabic: "بني َدروم",
  },
  {
    city_name: "בני דרור",
    city_name_arabic: "بني درور",
  },
  {
    city_name: "בני יהודה",
    city_name_arabic: "بني يهودا",
  },
  {
    city_name: "בני נצרים",
    city_name_arabic: "Bne Netsarim",
  },
  {
    city_name: "בני עטרות",
    city_name_arabic: "بني َعتَروت",
  },
  {
    city_name: 'בני עי"ש',
    city_name_arabic: "بني عايش",
  },
  {
    city_name: "בני ציון",
    city_name_arabic: "بني تسيون",
  },
  {
    city_name: "בני ראם",
    city_name_arabic: "بني رئيم",
  },
  {
    city_name: "בניה",
    city_name_arabic: "بنَيا",
  },
  {
    city_name: "בנימינה-גבעת עדה",
    city_name_arabic: "بن َيمينا",
  },
  {
    city_name: 'בסמ"ה',
    city_name_arabic: "بسمة",
  },
  {
    city_name: "בסמת טבעון",
    city_name_arabic: "بسمة طبعون",
  },
  {
    city_name: "בענה",
    city_name_arabic: "Bi'ne",
  },
  {
    city_name: "בצרה",
    city_name_arabic: "َبتسرا",
  },
  {
    city_name: "בצת",
    city_name_arabic: "بيتست",
  },
  {
    city_name: "בקוע",
    city_name_arabic: "بكو َوع",
  },
  {
    city_name: "בקעות",
    city_name_arabic: "ب َكعوت",
  },
  {
    city_name: "בר גיורא",
    city_name_arabic: "بار چيورا",
  },
  {
    city_name: "בר יוחאי",
    city_name_arabic: "بار يوحاي",
  },
  {
    city_name: "ברוכין",
    city_name_arabic: "Brukhin",
  },
  {
    city_name: "ברור חיל",
    city_name_arabic: "برور حايل",
  },
  {
    city_name: "ברוש",
    city_name_arabic: "بروش",
  },
  {
    city_name: "ברכה",
    city_name_arabic: "ب َرخا",
  },
  {
    city_name: "ברכיה",
    city_name_arabic: "برخيا",
  },
  {
    city_name: "ברעם",
    city_name_arabic: "برعام",
  },
  {
    city_name: "ברק",
    city_name_arabic: "َبراك",
  },
  {
    city_name: "ברקאי",
    city_name_arabic: "َبركاي",
  },
  {
    city_name: "ברקן",
    city_name_arabic: "َبركان",
  },
  {
    city_name: "ברקת",
    city_name_arabic: "َبريكت",
  },
  {
    city_name: "בת הדר",
    city_name_arabic: "بات َهدار",
  },
  {
    city_name: "בת חן",
    city_name_arabic: "بات حين",
  },
  {
    city_name: "בת חפר",
    city_name_arabic: "بات حيفر",
  },
  {
    city_name: "בת חצור",
    city_name_arabic: "فتاة العاصور ",
  },
  {
    city_name: "בת ים",
    city_name_arabic: "بات يام",
  },
  {
    city_name: "בת עין",
    city_name_arabic: "بات عاين",
  },
  {
    city_name: "בת שלמה",
    city_name_arabic: "بات شلومو",
  },
  {
    city_name: "ג'דיידה-מכר",
    city_name_arabic: "جديدة – مكر",
  },
  {
    city_name: "ג'ולס",
    city_name_arabic: "جولس",
  },
  {
    city_name: "ג'לג'וליה",
    city_name_arabic: "جلجولية",
  },
  {
    city_name: "ג'נאביב (שבט)",
    city_name_arabic: "Junabib",
  },
  {
    city_name: "ג'סר א-זרקא",
    city_name_arabic: "جِسْر الزَّرْقاء",
  },
  {
    city_name: "ג'ש (גוש חלב)",
    city_name_arabic: "جش (چوش حالڤ)",
  },
  {
    city_name: "ג'ת",
    city_name_arabic: "Jatt",
  },
  {
    city_name: "גאולי תימן",
    city_name_arabic: "چؤولي تيمان",
  },
  {
    city_name: "גאולים",
    city_name_arabic: "چؤوليم",
  },
  {
    city_name: "גאליה",
    city_name_arabic: "چأليا",
  },
  {
    city_name: "גבולות",
    city_name_arabic: "چڤولوت",
  },
  {
    city_name: "גבים",
    city_name_arabic: "چڤيم",
  },
  {
    city_name: "גבע",
    city_name_arabic: "چيڤَع",
  },
  {
    city_name: "גבע בנימין",
    city_name_arabic: "چيڤَع بن َيمين",
  },
  {
    city_name: "גבע כרמל",
    city_name_arabic: "چيڤَع كرميل",
  },
  {
    city_name: "גבעולים",
    city_name_arabic: "چڤعوليم",
  },
  {
    city_name: "גבעון החדשה",
    city_name_arabic: "چڤعون ه َح َدشا",
  },
  {
    city_name: "גבעות בר",
    city_name_arabic: "چڤعوت بار",
  },
  {
    city_name: "גבעת אבני",
    city_name_arabic: "چڤعات أڤني",
  },
  {
    city_name: "גבעת אלה",
    city_name_arabic: "چڤعات إلا",
  },
  {
    city_name: "גבעת ברנר",
    city_name_arabic: "چڤعات برينر",
  },
  {
    city_name: "גבעת השלושה",
    city_name_arabic: "چڤعات هشلوشا",
  },
  {
    city_name: "גבעת זאב",
    city_name_arabic: "چڤعات زئيڤ",
  },
  {
    city_name: 'גבעת ח"ן',
    city_name_arabic: "چڤعات حين",
  },
  {
    city_name: "גבעת חיים (איחוד)",
    city_name_arabic: "چڤعات َحييم (إيحود)",
  },
  {
    city_name: "גבעת חיים (מאוחד)",
    city_name_arabic: "چڤعات َحييم (مؤحاد)",
  },
  {
    city_name: "גבעת יואב",
    city_name_arabic: "چڤعات يوآڤ",
  },
  {
    city_name: "גבעת יערים",
    city_name_arabic: "چڤعات ي َعريم ",
  },
  {
    city_name: "גבעת ישעיהו",
    city_name_arabic: "چڤعاتي َشعياهو",
  },
  {
    city_name: 'גבעת כ"ח',
    city_name_arabic: "چڤعات كو َوح",
  },
  {
    city_name: 'גבעת ניל"י',
    city_name_arabic: "چڤعات نيلي",
  },
  {
    city_name: "גבעת עוז",
    city_name_arabic: "چڤعات عوز",
  },
  {
    city_name: "גבעת שמואל",
    city_name_arabic: "چڤعات شموئيل",
  },
  {
    city_name: "גבעת שמש",
    city_name_arabic: "چڤعات شيمش",
  },
  {
    city_name: "גבעת שפירא",
    city_name_arabic: "چڤعات َشپيرا",
  },
  {
    city_name: "גבעתי",
    city_name_arabic: "چڤعتي",
  },
  {
    city_name: "גבעתיים",
    city_name_arabic: "چڤ َعتايم",
  },
  {
    city_name: "גברעם",
    city_name_arabic: "چڤرعام",
  },
  {
    city_name: "גבת",
    city_name_arabic: "چڤات",
  },
  {
    city_name: "גדות",
    city_name_arabic: "چدوت",
  },
  {
    city_name: "גדיש",
    city_name_arabic: "چديش",
  },
  {
    city_name: "גדעונה",
    city_name_arabic: "چدعونا",
  },
  {
    city_name: "גדרה",
    city_name_arabic: "چدرا",
  },
  {
    city_name: "גונן",
    city_name_arabic: "چونين",
  },
  {
    city_name: "גורן",
    city_name_arabic: "چورن",
  },
  {
    city_name: "גורנות הגליל",
    city_name_arabic: "چرنوت هچليل",
  },
  {
    city_name: "גזית",
    city_name_arabic: "َچزيت",
  },
  {
    city_name: "גזר",
    city_name_arabic: "چيزر",
  },
  {
    city_name: "גיאה",
    city_name_arabic: "چيئة",
  },
  {
    city_name: "גיבתון",
    city_name_arabic: "چبتون",
  },
  {
    city_name: "גיזו",
    city_name_arabic: "چيزو",
  },
  {
    city_name: "גילון",
    city_name_arabic: "چيلون",
  },
  {
    city_name: "גילת",
    city_name_arabic: "چيلات",
  },
  {
    city_name: "גינוסר",
    city_name_arabic: "چنوسار",
  },
  {
    city_name: "גיניגר",
    city_name_arabic: "چنيچار",
  },
  {
    city_name: "גינתון",
    city_name_arabic: "چنتون",
  },
  {
    city_name: "גיתה",
    city_name_arabic: "چتا",
  },
  {
    city_name: "גיתית",
    city_name_arabic: "چتيت",
  },
  {
    city_name: "גלאון",
    city_name_arabic: "چلؤون",
  },
  {
    city_name: "גלגל",
    city_name_arabic: "چلچال",
  },
  {
    city_name: "גליל ים",
    city_name_arabic: "چليل يام",
  },
  {
    city_name: "גלעד (אבן יצחק)",
    city_name_arabic: "چلعاد (بين يتسحاك)",
  },
  {
    city_name: "גמזו",
    city_name_arabic: "چمزو",
  },
  {
    city_name: "גן הדרום",
    city_name_arabic: "چان هدَروم",
  },
  {
    city_name: "גן השומרון",
    city_name_arabic: "چان هشومرون",
  },
  {
    city_name: "גן חיים",
    city_name_arabic: "چان ه َحييم",
  },
  {
    city_name: "גן יאשיה",
    city_name_arabic: "چان يوشيا",
  },
  {
    city_name: "גן יבנה",
    city_name_arabic: "چان يڤني",
  },
  {
    city_name: "גן נר",
    city_name_arabic: "چان نير",
  },
  {
    city_name: "גן שורק",
    city_name_arabic: "چان سوريك",
  },
  {
    city_name: "גן שלמה",
    city_name_arabic: "چان شلومو",
  },
  {
    city_name: "גן שמואל",
    city_name_arabic: "چان شموئيل",
  },
  {
    city_name: "גנות",
    city_name_arabic: "َچنوت",
  },
  {
    city_name: "גנות הדר",
    city_name_arabic: "چنوت هدار",
  },
  {
    city_name: "גני הדר",
    city_name_arabic: "چني هدار",
  },
  {
    city_name: "גני טל",
    city_name_arabic: " Tal Gane",
  },
  {
    city_name: "גני יוחנן",
    city_name_arabic: "چني يو َحنان",
  },
  {
    city_name: "גני מודיעין",
    city_name_arabic: "Gane Modi'in ",
  },
  {
    city_name: "גני עם",
    city_name_arabic: "چني عام",
  },
  {
    city_name: "גני תקווה",
    city_name_arabic: " چني ت كڤا",
  },
  {
    city_name: "געש",
    city_name_arabic: "چاعَش",
  },
  {
    city_name: "געתון",
    city_name_arabic: "چ عتون",
  },
  {
    city_name: "גפן",
    city_name_arabic: "چي فن",
  },
  {
    city_name: "גרופית",
    city_name_arabic: "چروفيت",
  },
  {
    city_name: "גשור",
    city_name_arabic: "چشور",
  },
  {
    city_name: "גשר",
    city_name_arabic: " چي شر",
  },
  {
    city_name: "גשר הזיו",
    city_name_arabic: "چي شر هزيڤ",
  },
  {
    city_name: "גת (קיבוץ)",
    city_name_arabic: "چات )كيبوت س(",
  },
  {
    city_name: "גת רימון",
    city_name_arabic: "چات رمون",
  },
  {
    city_name: "דאלית אל-כרמל",
    city_name_arabic: "دالية الكرمل",
  },
  {
    city_name: "דבורה",
    city_name_arabic: "دڤورا",
  },
  {
    city_name: "דבוריה",
    city_name_arabic: "دبورية",
  },
  {
    city_name: "דבירה",
    city_name_arabic: "دڤيرا",
  },
  {
    city_name: "דברת",
    city_name_arabic: "دڤرات",
  },
  {
    city_name: "דגניה א'",
    city_name_arabic: "دچنيا أ",
  },
  {
    city_name: "דגניה ב'",
    city_name_arabic: "دچنيا ب",
  },
  {
    city_name: 'דוב"ב',
    city_name_arabic: "دوڤيڤ",
  },
  {
    city_name: "דולב",
    city_name_arabic: "دولڤ",
  },
  {
    city_name: "דור",
    city_name_arabic: "دور",
  },
  {
    city_name: "דורות",
    city_name_arabic: "دوروت",
  },
  {
    city_name: "דחי",
    city_name_arabic: "دحي",
  },
  {
    city_name: "דייר אל-אסד",
    city_name_arabic: "d El Deir",
  },
  {
    city_name: "דייר חנא",
    city_name_arabic: "دير حنا",
  },
  {
    city_name: "דייר ראפאת",
    city_name_arabic: "دير رافات",
  },
  {
    city_name: "דימונה",
    city_name_arabic: "ديمونا",
  },
  {
    city_name: "דישון",
    city_name_arabic: "ديشون",
  },
  {
    city_name: "דליה",
    city_name_arabic: "دلي",
  },
  {
    city_name: "דלתון",
    city_name_arabic: "دلتون",
  },
  {
    city_name: "דמיידה",
    city_name_arabic: "ضميدة",
  },
  {
    city_name: "דן",
    city_name_arabic: "دان",
  },
  {
    city_name: "דפנה",
    city_name_arabic: "دفنا",
  },
  {
    city_name: "דקל",
    city_name_arabic: "دي كل",
  },
  {
    city_name: "דריג'את",
    city_name_arabic: "دريجات",
  },
  {
    city_name: "האון",
    city_name_arabic: "َهؤون",
  },
  {
    city_name: "הבונים",
    city_name_arabic: "هبونيم",
  },
  {
    city_name: "הגושרים",
    city_name_arabic: "هچوشريم",
  },
  {
    city_name: "הדר עם",
    city_name_arabic: "هدار عام",
  },
  {
    city_name: "הוד השרון",
    city_name_arabic: "هود هشَ رون",
  },
  {
    city_name: "הודיה",
    city_name_arabic: "هو ديا",
  },
  {
    city_name: "הודיות",
    city_name_arabic: "هوَديوت",
  },
  {
    city_name: "הוואשלה (שבט)",
    city_name_arabic: "Hawashla",
  },
  {
    city_name: "הוזייל (שבט)",
    city_name_arabic: "Huzayel",
  },
  {
    city_name: "הושעיה",
    city_name_arabic: "هوشعيا",
  },
  {
    city_name: "הזורע",
    city_name_arabic: "هزوري َيع",
  },
  {
    city_name: "הזורעים",
    city_name_arabic: "هزورعيم",
  },
  {
    city_name: "החותרים",
    city_name_arabic: "هحوتريم",
  },
  {
    city_name: "היוגב",
    city_name_arabic: "هيوچيب",
  },
  {
    city_name: "הילה",
    city_name_arabic: "هلا",
  },
  {
    city_name: "המעפיל",
    city_name_arabic: "همعپيل",
  },
  {
    city_name: "הסוללים",
    city_name_arabic: "هسولليم",
  },
  {
    city_name: "העוגן",
    city_name_arabic: "هعوچن",
  },
  {
    city_name: "הר אדר",
    city_name_arabic: "هار أدار",
  },
  {
    city_name: "הר גילה",
    city_name_arabic: "هار چيلو",
  },
  {
    city_name: "הר עמשא",
    city_name_arabic: "هار ع َمسا",
  },
  {
    city_name: "הראל",
    city_name_arabic: "هرئيل",
  },
  {
    city_name: "הרדוף",
    city_name_arabic: "هردوف",
  },
  {
    city_name: "הרצליה",
    city_name_arabic: "هرتسليا",
  },
  {
    city_name: "הררית",
    city_name_arabic: "ه َرريت",
  },
  {
    city_name: "ורד יריחו",
    city_name_arabic: "ڤيرد يريحو",
  },
  {
    city_name: "ורדון",
    city_name_arabic: "ڤردون",
  },
  {
    city_name: "זבארגה (שבט)",
    city_name_arabic: "Zabarga",
  },
  {
    city_name: "זבדיאל",
    city_name_arabic: "زڤديئيل",
  },
  {
    city_name: "זוהר",
    city_name_arabic: "زو َهر",
  },
  {
    city_name: "זיקים",
    city_name_arabic: "زكيم",
  },
  {
    city_name: "זיתן",
    city_name_arabic: "زيتان",
  },
  {
    city_name: "זכרון יעקב",
    city_name_arabic: "زخرون ي َعكوڤ",
  },
  {
    city_name: "זכריה",
    city_name_arabic: "زخريا",
  },
  {
    city_name: "זמר",
    city_name_arabic: "زيمر",
  },
  {
    city_name: "זמרת",
    city_name_arabic: "زمرات",
  },
  {
    city_name: "זנוח",
    city_name_arabic: "َزنو َوح",
  },
  {
    city_name: "זרועה",
    city_name_arabic: "زروعا",
  },
  {
    city_name: "זרזיר",
    city_name_arabic: "زرزير",
  },
  {
    city_name: "זרחיה",
    city_name_arabic: "زرحيا",
  },
  {
    city_name: "ח'ואלד",
    city_name_arabic: "خوالد",
  },
  {
    city_name: "ח'ואלד (שבט)",
    city_name_arabic: "خوالد",
  },
  {
    city_name: "חבצלת השרון",
    city_name_arabic: "حڤَتسيلت ه َشرون",
  },
  {
    city_name: "חבר",
    city_name_arabic: "حيڤر",
  },
  {
    city_name: "חברון",
    city_name_arabic: "الخليل",
  },
  {
    city_name: "חגור",
    city_name_arabic: "حچور",
  },
  {
    city_name: "חגי",
    city_name_arabic: "َحچاي",
  },
  {
    city_name: "חגלה",
    city_name_arabic: "حچلا",
  },
  {
    city_name: "חד-נס",
    city_name_arabic: "حاد نيس",
  },
  {
    city_name: "חדיד",
    city_name_arabic: "حديد",
  },
  {
    city_name: "חדרה",
    city_name_arabic: "َحدرا",
  },
  {
    city_name: "חוג'ייראת (ד'הרה)",
    city_name_arabic: "Hujeirat (Dahra)",
  },
  {
    city_name: "חולדה",
    city_name_arabic: "حلدا",
  },
  {
    city_name: "חולון",
    city_name_arabic: "حولون",
  },
  {
    city_name: "חולית",
    city_name_arabic: "حوليت",
  },
  {
    city_name: "חולתה",
    city_name_arabic: "حولاتا",
  },
  {
    city_name: "חוסן",
    city_name_arabic: "حوسن",
  },
  {
    city_name: "חוסנייה",
    city_name_arabic: "حسنية",
  },
  {
    city_name: "חופית",
    city_name_arabic: "حوفيت",
  },
  {
    city_name: "חוקוק",
    city_name_arabic: "حوكوك",
  },
  {
    city_name: "חורה",
    city_name_arabic: "حورة",
  },
  {
    city_name: "חורפיש",
    city_name_arabic: "حرفيش",
  },
  {
    city_name: "חורשים",
    city_name_arabic: "حورشيم",
  },
  {
    city_name: "חזון",
    city_name_arabic: "حزون",
  },
  {
    city_name: "חיבת ציון",
    city_name_arabic: "حبات تسيون",
  },
  {
    city_name: "חיננית",
    city_name_arabic: "حننيت",
  },
  {
    city_name: "חיפה",
    city_name_arabic: "حيفا",
  },
  {
    city_name: "חירות",
    city_name_arabic: "حروت",
  },
  {
    city_name: "חלוץ",
    city_name_arabic: "حلوتس",
  },
  {
    city_name: "חלץ",
    city_name_arabic: "حيلتس",
  },
  {
    city_name: "חמאם",
    city_name_arabic: "حمام",
  },
  {
    city_name: "חמד",
    city_name_arabic: "حيمد",
  },
  {
    city_name: "חמדיה",
    city_name_arabic: "ح َمديا",
  },
  {
    city_name: "חמדת",
    city_name_arabic: "حمدات",
  },
  {
    city_name: "חמרה",
    city_name_arabic: "حمرا",
  },
  {
    city_name: "חניאל",
    city_name_arabic: "حنيئيل",
  },
  {
    city_name: "חניתה",
    city_name_arabic: "َحنيتا",
  },
  {
    city_name: "חנתון",
    city_name_arabic: "حنَتون",
  },
  {
    city_name: "חספין",
    city_name_arabic: "حسپين",
  },
  {
    city_name: "חפץ חיים",
    city_name_arabic: "حفيتس حييم",
  },
  {
    city_name: "חפצי-בה",
    city_name_arabic: "حفتسيڤا",
  },
  {
    city_name: "חצב",
    city_name_arabic: "حتساڤ",
  },
  {
    city_name: "חצבה",
    city_name_arabic: "حتسڤا",
  },
  {
    city_name: "חצור הגלילית",
    city_name_arabic: "حتسور هچليليت",
  },
  {
    city_name: "חצור-אשדוד",
    city_name_arabic: "حتسور-أشدود",
  },
  {
    city_name: "חצר בארותיים",
    city_name_arabic: "ساحه بمئروتاي",
  },
  {
    city_name: "חצרות חולדה",
    city_name_arabic: "ساحات خلدة",
  },
  {
    city_name: 'חצרות כ"ח',
    city_name_arabic: "Hatzerot kaf het ",
  },
  {
    city_name: "חצרים",
    city_name_arabic: "حتسريم",
  },
  {
    city_name: "חרב לאת",
    city_name_arabic: "حيرڤ لئيت",
  },
  {
    city_name: "חרוצים",
    city_name_arabic: "حروتسيم",
  },
  {
    city_name: "חריש",
    city_name_arabic: "Harish",
  },
  {
    city_name: "חרמש",
    city_name_arabic: "حرميش",
  },
  {
    city_name: "חרשים",
    city_name_arabic: "ح َرشيم",
  },
  {
    city_name: "חשמונאים",
    city_name_arabic: "حشمونَئيم",
  },
  {
    city_name: "טבריה",
    city_name_arabic: "تڤريا",
  },
  {
    city_name: "טובא-זנגריה",
    city_name_arabic: "طوبا-زنجرية",
  },
  {
    city_name: "טורעאן",
    city_name_arabic: "طرعان",
  },
  {
    city_name: "טייבה",
    city_name_arabic: "طيبة",
  },
  {
    city_name: "טייבה (בעמק)",
    city_name_arabic: "طيبة",
  },
  {
    city_name: "טירה",
    city_name_arabic: "طيرة",
  },
  {
    city_name: "טירת יהודה",
    city_name_arabic: "تيرات يهودا",
  },
  {
    city_name: "טירת כרמל",
    city_name_arabic: "تييرات َكرميل",
  },
  {
    city_name: "טירת צבי",
    city_name_arabic: "تييرات تسڤي",
  },
  {
    city_name: "טל שחר",
    city_name_arabic: "طال شا َحر",
  },
  {
    city_name: "טל-אל",
    city_name_arabic: "طال إيل",
  },
  {
    city_name: "טללים",
    city_name_arabic: "طلَليم",
  },
  {
    city_name: "טלמון",
    city_name_arabic: "طلمون",
  },
  {
    city_name: "טמרה",
    city_name_arabic: "طمرة",
  },
  {
    city_name: "טמרה (יזרעאל)",
    city_name_arabic: "طمرة",
  },
  {
    city_name: "טנא",
    city_name_arabic: "طيني",
  },
  {
    city_name: "טפחות",
    city_name_arabic: "طفَحوت",
  },
  {
    city_name: "יאנוח-ג'ת",
    city_name_arabic: "يانوح–جت",
  },
  {
    city_name: "יבול",
    city_name_arabic: "يڤول",
  },
  {
    city_name: "יבנאל",
    city_name_arabic: "يڤنئيل",
  },
  {
    city_name: "יבנה",
    city_name_arabic: "يڤني",
  },
  {
    city_name: "יגור",
    city_name_arabic: "يچور",
  },
  {
    city_name: "יגל",
    city_name_arabic: "َيچيل",
  },
  {
    city_name: "יד בנימין",
    city_name_arabic: "ياد بنيمين",
  },
  {
    city_name: "יד השמונה",
    city_name_arabic: "ياد هشمونا",
  },
  {
    city_name: "יד חנה",
    city_name_arabic: "ياد حنا",
  },
  {
    city_name: "יד מרדכי",
    city_name_arabic: "ياد مردخاي",
  },
  {
    city_name: "יד נתן",
    city_name_arabic: "ياد نتان",
  },
  {
    city_name: 'יד רמב"ם',
    city_name_arabic: "ياد رمبام",
  },
  {
    city_name: "ידידה",
    city_name_arabic: "يهود",
  },
  {
    city_name: "יהוד-מונוסון",
    city_name_arabic: "يهود",
  },
  {
    city_name: "יהל",
    city_name_arabic: "يهيل",
  },
  {
    city_name: "יובל",
    city_name_arabic: "يوڤال",
  },
  {
    city_name: "יובלים",
    city_name_arabic: "يوڤَليم",
  },
  {
    city_name: "יודפת",
    city_name_arabic: "يودفات",
  },
  {
    city_name: "יונתן",
    city_name_arabic: "يونتان",
  },
  {
    city_name: "יושיביה",
    city_name_arabic: "يوشڤيا",
  },
  {
    city_name: "יזרעאל",
    city_name_arabic: "يزرعيل",
  },
  {
    city_name: "יחיעם",
    city_name_arabic: "يحيعام",
  },
  {
    city_name: "יטבתה",
    city_name_arabic: "يتڤاتا",
  },
  {
    city_name: 'ייט"ב',
    city_name_arabic: "ييتاڤ",
  },
  {
    city_name: "יכיני",
    city_name_arabic: "َيخيني",
  },
  {
    city_name: "ינוב",
    city_name_arabic: "َينوڤ",
  },
  {
    city_name: "ינון",
    city_name_arabic: "ينون",
  },
  {
    city_name: "יסוד המעלה",
    city_name_arabic: "يسود ه َمعلا",
  },
  {
    city_name: "יסודות",
    city_name_arabic: "يسودوت",
  },
  {
    city_name: "יסעור",
    city_name_arabic: "يسعور",
  },
  {
    city_name: "יעד",
    city_name_arabic: "ياَعد",
  },
  {
    city_name: "יעל",
    city_name_arabic: "يعيل",
  },
  {
    city_name: "יעף",
    city_name_arabic: "ياَعف",
  },
  {
    city_name: "יערה",
    city_name_arabic: "يعَرا",
  },
  {
    city_name: "יפיע",
    city_name_arabic: "يفيع",
  },
  {
    city_name: "יפית",
    city_name_arabic: "يفيت",
  },
  {
    city_name: "יפעת",
    city_name_arabic: "يفعات",
  },
  {
    city_name: "יפתח",
    city_name_arabic: "يفتاح",
  },
  {
    city_name: "יצהר",
    city_name_arabic: "يتسهار",
  },
  {
    city_name: "יציץ",
    city_name_arabic: "َيتسيتس",
  },
  {
    city_name: "יקום",
    city_name_arabic: "يكوم",
  },
  {
    city_name: "יקיר",
    city_name_arabic: "يكير",
  },
  {
    city_name: "יקנעם (מושבה)",
    city_name_arabic: "يكنعام (موشڤا)",
  },
  {
    city_name: "יקנעם עילית",
    city_name_arabic: "ي كن عام عليت",
  },
  {
    city_name: "יראון",
    city_name_arabic: " يرؤون",
  },
  {
    city_name: "ירדנה",
    city_name_arabic: "ي ر دنا",
  },
  {
    city_name: "ירוחם",
    city_name_arabic: "يرحام",
  },
  {
    city_name: "ירושלים",
    city_name_arabic: "أورشليم",
  },
  {
    city_name: "ירחיב",
    city_name_arabic: "يَرحيڤ",
  },
  {
    city_name: "ירכא",
    city_name_arabic: "يركا",
  },
  {
    city_name: "ירקונה",
    city_name_arabic: "يركونا",
  },
  {
    city_name: "ישע",
    city_name_arabic: "ييَشع",
  },
  {
    city_name: "ישעי",
    city_name_arabic: "يشعي",
  },
  {
    city_name: "ישרש",
    city_name_arabic: "يَش رش",
  },
  {
    city_name: "יתד",
    city_name_arabic: "يَتيد",
  },
  {
    city_name: "יתיר",
    city_name_arabic: "يَتير",
  },
  {
    city_name: "כאבול",
    city_name_arabic: "كابول",
  },
  {
    city_name: "כאוכב אבו אל-היג'א",
    city_name_arabic: "كوكب أبو الهيجا",
  },
  {
    city_name: "כברי",
    city_name_arabic: "كا بري",
  },
  {
    city_name: "כדורי",
    city_name_arabic: "كدوري",
  },
  {
    city_name: "כדיתה",
    city_name_arabic: "Kadita",
  },
  {
    city_name: "כוכב השחר",
    city_name_arabic: "كوخاڤ هشا َحر",
  },
  {
    city_name: "כוכב יאיר",
    city_name_arabic: "كوخاڤ َيئير",
  },
  {
    city_name: "כוכב יעקב",
    city_name_arabic: "كوخاڤ ي َعكوڤ",
  },
  {
    city_name: "כוכב מיכאל",
    city_name_arabic: "كوخاڤ مي َخئيل",
  },
  {
    city_name: "כורזים",
    city_name_arabic: "كورزيم",
  },
  {
    city_name: "כחל",
    city_name_arabic: "كا َحل",
  },
  {
    city_name: "כחלה",
    city_name_arabic: "Kuhla",
  },
  {
    city_name: "כיסופים",
    city_name_arabic: "كسوفيم",
  },
  {
    city_name: "כישור",
    city_name_arabic: "كيشور",
  },
  {
    city_name: "כליל",
    city_name_arabic: "كليل",
  },
  {
    city_name: "כלנית",
    city_name_arabic: "كلَنيت",
  },
  {
    city_name: "כמאנה",
    city_name_arabic: "كمانة",
  },
  {
    city_name: "כמהין",
    city_name_arabic: "كمهين",
  },
  {
    city_name: "כמון",
    city_name_arabic: "كمون",
  },
  {
    city_name: "כנות",
    city_name_arabic: "كنوت",
  },
  {
    city_name: "כנף",
    city_name_arabic: "َكناف",
  },
  {
    city_name: "כנרת (מושבה)",
    city_name_arabic: "كنيرت (موشڤا)",
  },
  {
    city_name: "כנרת (קבוצה)",
    city_name_arabic: "كنيرت (قڤوتشا)",
  },
  {
    city_name: "כסיפה",
    city_name_arabic: "كسيفة",
  },
  {
    city_name: "כסלון",
    city_name_arabic: "كسلون",
  },
  {
    city_name: "כסרא-סמיע",
    city_name_arabic: "كس ار – سميع",
  },
  {
    city_name: "כעביה-טבאש-חג'אג'רה",
    city_name_arabic: "كعبية–طباش–حجاجرة",
  },
  {
    city_name: "כפר אביב",
    city_name_arabic: "كفار أڤيڤ",
  },
  {
    city_name: "כפר אדומים",
    city_name_arabic: "كفار أدميم",
  },
  {
    city_name: "כפר אוריה",
    city_name_arabic: "كفار أوريا",
  },
  {
    city_name: "כפר אחים",
    city_name_arabic: "كفار أحيم",
  },
  {
    city_name: "כפר ביאליק",
    city_name_arabic: "كفار بياليك",
  },
  {
    city_name: 'כפר ביל"ו',
    city_name_arabic: "كفار بيلو",
  },
  {
    city_name: "כפר בלום",
    city_name_arabic: "كفار بلوم",
  },
  {
    city_name: "כפר בן נון",
    city_name_arabic: "كفار بين نون",
  },
  {
    city_name: "כפר ברא",
    city_name_arabic: "كفر برا",
  },
  {
    city_name: "כפר ברוך",
    city_name_arabic: "كفار بروخ",
  },
  {
    city_name: "כפר גדעון",
    city_name_arabic: "كفار چدعون",
  },
  {
    city_name: "כפר גלים",
    city_name_arabic: "كفار چليم",
  },
  {
    city_name: "כפר גליקסון",
    city_name_arabic: "كفار چليكسون",
  },
  {
    city_name: "כפר גלעדי",
    city_name_arabic: "كفار چلعدي",
  },
  {
    city_name: "כפר דניאל",
    city_name_arabic: "كفار دنيييل",
  },
  {
    city_name: "כפר האורנים",
    city_name_arabic: "كفار هأرنيم",
  },
  {
    city_name: "כפר החורש",
    city_name_arabic: "كفار هحورش",
  },
  {
    city_name: "כפר המכבי",
    city_name_arabic: "كفار ه َم َكبي",
  },
  {
    city_name: "כפר הנגיד",
    city_name_arabic: "كفار ه َنچيد",
  },
  {
    city_name: "כפר הנוער הדתי",
    city_name_arabic: "كفار هنو َعر هدتي",
  },
  {
    city_name: "כפר הנשיא",
    city_name_arabic: "كفار هنَسي",
  },
  {
    city_name: "כפר הס",
    city_name_arabic: "كفار هيس",
  },
  {
    city_name: 'כפר הרא"ה',
    city_name_arabic: "كفار هروئي",
  },
  {
    city_name: 'כפר הרי"ף',
    city_name_arabic: "كفار هريف",
  },
  {
    city_name: "כפר ויתקין",
    city_name_arabic: "كفار ڤيتكين",
  },
  {
    city_name: "כפר ורבורג",
    city_name_arabic: "كفار ڤاربورچ",
  },
  {
    city_name: "כפר ורדים",
    city_name_arabic: "كفار ڤرديم",
  },
  {
    city_name: "כפר זוהרים",
    city_name_arabic: "كفار ز َهريم",
  },
  {
    city_name: "כפר זיתים",
    city_name_arabic: "كفار زيتيم",
  },
  {
    city_name: 'כפר חב"ד',
    city_name_arabic: "كفار َحباد",
  },
  {
    city_name: "כפר חושן",
    city_name_arabic: "كفار حوشن",
  },
  {
    city_name: "כפר חיטים",
    city_name_arabic: "كفار حتيم",
  },
  {
    city_name: "כפר חיים",
    city_name_arabic: "كفار َحييم",
  },
  {
    city_name: "כפר חנניה",
    city_name_arabic: "كفار حننيا",
  },
  {
    city_name: "כפר חסידים א'",
    city_name_arabic: "كفار حسيديم أ",
  },
  {
    city_name: "כפר חסידים ב'",
    city_name_arabic: "كفار حسيديم ب",
  },
  {
    city_name: "כפר חרוב",
    city_name_arabic: "كفار َحروڤ",
  },
  {
    city_name: "כפר טרומן",
    city_name_arabic: "كفار ترو َمن",
  },
  {
    city_name: "כפר יאסיף",
    city_name_arabic: "كفر ياسيف",
  },
  {
    city_name: "כפר ידידיה",
    city_name_arabic: "كفار يديديا",
  },
  {
    city_name: "כפר יהושע",
    city_name_arabic: "كفار يهوشو َوع",
  },
  {
    city_name: "כפר יונה",
    city_name_arabic: "كفار يونا",
  },
  {
    city_name: "כפר יחזקאל",
    city_name_arabic: "كفار يحزكيل",
  },
  {
    city_name: "כפר יעבץ",
    city_name_arabic: "كفار يعبيتس",
  },
  {
    city_name: "כפר כמא",
    city_name_arabic: "كفر كما",
  },
  {
    city_name: "כפר כנא",
    city_name_arabic: "كفر كنا",
  },
  {
    city_name: "כפר מונש",
    city_name_arabic: "كفار موناش",
  },
  {
    city_name: "כפר מימון",
    city_name_arabic: "كفار ميمون",
  },
  {
    city_name: 'כפר מל"ל',
    city_name_arabic: "كفار َملال",
  },
  {
    city_name: "כפר מנדא",
    city_name_arabic: "كفر مندا",
  },
  {
    city_name: "כפר מנחם",
    city_name_arabic: "كفار منَحيم",
  },
  {
    city_name: "כפר מסריק",
    city_name_arabic: "كفار مساريق",
  },
  {
    city_name: "כפר מצר",
    city_name_arabic: "كفر مصر",
  },
  {
    city_name: "כפר מרדכי",
    city_name_arabic: "كفار مردخاي",
  },
  {
    city_name: "כפר נטר",
    city_name_arabic: "كفار نيتر",
  },
  {
    city_name: "כפר סאלד",
    city_name_arabic: "كفار سولد",
  },
  {
    city_name: "כפר סבא",
    city_name_arabic: "كفار َسڤا",
  },
  {
    city_name: "כפר סילבר",
    city_name_arabic: "كفار سيلڤر",
  },
  {
    city_name: "כפר סירקין",
    city_name_arabic: "كفار سيركين",
  },
  {
    city_name: "כפר עבודה",
    city_name_arabic: "Kfar Avoda",
  },
  {
    city_name: "כפר עזה",
    city_name_arabic: "كفار عزا",
  },
  {
    city_name: "כפר עציון",
    city_name_arabic: "كفار عتسيون",
  },
  {
    city_name: "כפר פינס",
    city_name_arabic: "كفار پينس",
  },
  {
    city_name: "כפר קאסם",
    city_name_arabic: "كفر قاسم",
  },
  {
    city_name: "כפר קיש",
    city_name_arabic: "كفار كيش",
  },
  {
    city_name: "כפר קרע",
    city_name_arabic: "كفر قرع",
  },
  {
    city_name: "כפר ראש הנקרה",
    city_name_arabic: "كفار روش هنكرا",
  },
  {
    city_name: "כפר רוזנואלד (זרעית)",
    city_name_arabic: "Zar'it",
  },
  {
    city_name: "כפר רופין",
    city_name_arabic: "كفار روپين",
  },
  {
    city_name: "כפר רות",
    city_name_arabic: "كفار روت",
  },
  {
    city_name: "כפר שמאי",
    city_name_arabic: "كفار َشماي",
  },
  {
    city_name: "כפר שמואל",
    city_name_arabic: "كفار شموئيل",
  },
  {
    city_name: "כפר שמריהו",
    city_name_arabic: "كفار ش َمرياهو",
  },
  {
    city_name: "כפר תבור",
    city_name_arabic: "كفار تڤور",
  },
  {
    city_name: "כפר תפוח",
    city_name_arabic: "كفار تپو َوح",
  },
  {
    city_name: "כרי דשא",
    city_name_arabic: "كفار ديشي",
  },
  {
    city_name: "כרכום",
    city_name_arabic: "كركوم",
  },
  {
    city_name: "כרם בן זמרה",
    city_name_arabic: "كيرم بين زمرا",
  },
  {
    city_name: "כרם בן שמן",
    city_name_arabic: "كيرم بين شيمن",
  },
  {
    city_name: 'כרם מהר"ל',
    city_name_arabic: "كيرم َم َهرال",
  },
  {
    city_name: "כרם שלום",
    city_name_arabic: "كيرم شلوم",
  },
  {
    city_name: "כרמי יוסף",
    city_name_arabic: "كرمي يوسيف",
  },
  {
    city_name: "כרמי צור",
    city_name_arabic: "كرمي تسور",
  },
  {
    city_name: "כרמי קטיף",
    city_name_arabic: "Karmei Katif",
  },
  {
    city_name: "כרמיאל",
    city_name_arabic: "كرميئيل",
  },
  {
    city_name: "כרמיה",
    city_name_arabic: "كرميا",
  },
  {
    city_name: "כרמים",
    city_name_arabic: "ك َرميم",
  },
  {
    city_name: "כרמל",
    city_name_arabic: "كرميل",
  },
  {
    city_name: "לבון",
    city_name_arabic: "لَڤون",
  },
  {
    city_name: "לביא",
    city_name_arabic: "لَڤي",
  },
  {
    city_name: "לבנים",
    city_name_arabic: "لڤَنَيم",
  },
  {
    city_name: "להב",
    city_name_arabic: "لا َهڤ",
  },
  {
    city_name: "להבות הבשן",
    city_name_arabic: "لَ َهڤوت ه َبشان",
  },
  {
    city_name: "להבות חביבה",
    city_name_arabic: "لَ َهڤوت حڤيڤا",
  },
  {
    city_name: "להבים",
    city_name_arabic: "لهڤيم",
  },
  {
    city_name: "לוד",
    city_name_arabic: "لود",
  },
  {
    city_name: "לוזית",
    city_name_arabic: "لوزيت",
  },
  {
    city_name: "לוחמי הגיטאות",
    city_name_arabic: "لو َحمي هچتَؤوت",
  },
  {
    city_name: "לוטם",
    city_name_arabic: "لوتم",
  },
  {
    city_name: "לוטן",
    city_name_arabic: "لوتان",
  },
  {
    city_name: "לימן",
    city_name_arabic: "لي َمن",
  },
  {
    city_name: "לכיש",
    city_name_arabic: "لخيش",
  },
  {
    city_name: "לפיד",
    city_name_arabic: "لپيد",
  },
  {
    city_name: "לפידות",
    city_name_arabic: "لپيدوت",
  },
  {
    city_name: "לקיה",
    city_name_arabic: "لقية",
  },
  {
    city_name: "מאור",
    city_name_arabic: "َمؤور",
  },
  {
    city_name: "מאיר שפיה",
    city_name_arabic: "مئير شفيا",
  },
  {
    city_name: "מבוא ביתר",
    city_name_arabic: "مڤو بيتار",
  },
  {
    city_name: "מבוא דותן",
    city_name_arabic: "مڤو دوتان",
  },
  {
    city_name: "מבוא חורון",
    city_name_arabic: "مڤو حورون",
  },
  {
    city_name: "מבוא חמה",
    city_name_arabic: "مڤو حما",
  },
  {
    city_name: "מבוא מודיעים",
    city_name_arabic: "مڤو موديعيم",
  },
  {
    city_name: "מבואות ים",
    city_name_arabic: "مڤؤوت يام",
  },
  {
    city_name: "מבואות יריחו",
    city_name_arabic: "مڤؤوت أريحا",
  },
  {
    city_name: "מבועים",
    city_name_arabic: "مبوعيم",
  },
  {
    city_name: "מבטחים",
    city_name_arabic: "مڤتحيم",
  },
  {
    city_name: "מבקיעים",
    city_name_arabic: "مڤكيعيم",
  },
  {
    city_name: "מבשרת ציון",
    city_name_arabic: "مڤسيرت تسيون",
  },
  {
    city_name: "מג'ד אל-כרום",
    city_name_arabic: "Majd Al Kurum",
  },
  {
    city_name: "מג'דל שמס",
    city_name_arabic: "مجدل شمس",
  },
  {
    city_name: "מגאר",
    city_name_arabic: "المغار",
  },
  {
    city_name: "מגדים",
    city_name_arabic: "مچديم",
  },
  {
    city_name: "מגדל",
    city_name_arabic: "مچدال",
  },
  {
    city_name: "מגדל העמק",
    city_name_arabic: "مچدال هعيمك",
  },
  {
    city_name: "מגדל עוז",
    city_name_arabic: "مچدال عوز",
  },
  {
    city_name: "מגדלים",
    city_name_arabic: "مچدليم",
  },
  {
    city_name: "מגידו",
    city_name_arabic: "مچدو",
  },
  {
    city_name: "מגל",
    city_name_arabic: "مچال",
  },
  {
    city_name: "מגן",
    city_name_arabic: "مچين",
  },
  {
    city_name: "מגן שאול",
    city_name_arabic: "مچين َشؤول",
  },
  {
    city_name: "מגשימים",
    city_name_arabic: "مچشيميم",
  },
  {
    city_name: "מדרך עוז",
    city_name_arabic: "مدراخ عوز",
  },
  {
    city_name: "מדרשת בן גוריון",
    city_name_arabic: "مدريشت بين چوريون",
  },
  {
    city_name: "מדרשת רופין",
    city_name_arabic: "مدريشت روپين",
  },
  {
    city_name: "מודיעין עילית",
    city_name_arabic: "موديعين عليت",
  },
  {
    city_name: "מודיעין-מכבים-רעות",
    city_name_arabic: "موديعين",
  },
  {
    city_name: "מולדת",
    city_name_arabic: "Moledet",
  },
  {
    city_name: "מוצא עילית",
    city_name_arabic: "موتسا عليت",
  },
  {
    city_name: "מוקייבלה",
    city_name_arabic: "مقيبلة ",
  },
  {
    city_name: "מורן",
    city_name_arabic: "موران",
  },
  {
    city_name: "מורשת",
    city_name_arabic: "موريشت",
  },
  {
    city_name: "מזור",
    city_name_arabic: "مزور",
  },
  {
    city_name: "מזכרת בתיה",
    city_name_arabic: "َمزكيرت بتيا",
  },
  {
    city_name: "מזרע",
    city_name_arabic: "مزراع",
  },
  {
    city_name: "מזרעה",
    city_name_arabic: "مزرعة",
  },
  {
    city_name: "מחולה",
    city_name_arabic: "محولا",
  },
  {
    city_name: "מחנה הילה",
    city_name_arabic: "مُعَسْكَر هلا",
  },
  {
    city_name: "מחנה טלי",
    city_name_arabic: "مُعَسْكَر Tali",
  },
  {
    city_name: "מחנה יהודית",
    city_name_arabic: "مُعَسْكَر Yehudit",
  },
  {
    city_name: "מחנה יוכבד",
    city_name_arabic: "مُعَسْكَر Yocheved",
  },
  {
    city_name: "מחנה יפה",
    city_name_arabic: "مُعَسْكَر Yaffa",
  },
  {
    city_name: "מחנה יתיר",
    city_name_arabic: "مُعَسْكَر Yatir",
  },
  {
    city_name: "מחנה מרים",
    city_name_arabic: "مُعَسْكَر Miriyam",
  },
  {
    city_name: "מחנה תל נוף",
    city_name_arabic: "مُعَسْكَر Tel Nof",
  },
  {
    city_name: "מחניים",
    city_name_arabic: "محنايم",
  },
  {
    city_name: "מחסיה",
    city_name_arabic: "محسيا",
  },
  {
    city_name: "מטולה",
    city_name_arabic: "متولا",
  },
  {
    city_name: "מטע",
    city_name_arabic: "َمتاع",
  },
  {
    city_name: "מי עמי",
    city_name_arabic: "مي عمي",
  },
  {
    city_name: "מיטב",
    city_name_arabic: "ميتاڤ",
  },
  {
    city_name: "מייסר",
    city_name_arabic: "ميسر",
  },
  {
    city_name: "מיצר",
    city_name_arabic: "مضيق",
  },
  {
    city_name: "מירב",
    city_name_arabic: "مراڤ",
  },
  {
    city_name: "מירון",
    city_name_arabic: "ميرون",
  },
  {
    city_name: "מישר",
    city_name_arabic: "ميشار",
  },
  {
    city_name: "מיתר",
    city_name_arabic: "ميتار",
  },
  {
    city_name: "מכורה",
    city_name_arabic: "مخورا",
  },
  {
    city_name: "מכחול",
    city_name_arabic: "مكحول",
  },
  {
    city_name: "מכמורת",
    city_name_arabic: "مخمورت",
  },
  {
    city_name: "מכמנים",
    city_name_arabic: "مخمنيم",
  },
  {
    city_name: "מלאה",
    city_name_arabic: "ملئة",
  },
  {
    city_name: "מלילות",
    city_name_arabic: "مليلوت",
  },
  {
    city_name: "מלכיה",
    city_name_arabic: "ملكيا",
  },
  {
    city_name: "מלכישוע",
    city_name_arabic: "ملكيشو َوع",
  },
  {
    city_name: "מנוחה",
    city_name_arabic: "منوحا",
  },
  {
    city_name: "מנוף",
    city_name_arabic: "منوف",
  },
  {
    city_name: "מנות",
    city_name_arabic: "منوت",
  },
  {
    city_name: "מנחמיה",
    city_name_arabic: "منَحميا",
  },
  {
    city_name: "מנרה",
    city_name_arabic: "منارا",
  },
  {
    city_name: "מנשית זבדה",
    city_name_arabic: "منشية زبدة",
  },
  {
    city_name: "מסד",
    city_name_arabic: "مساد",
  },
  {
    city_name: "מסדה",
    city_name_arabic: "َمسادا",
  },
  {
    city_name: "מסילות",
    city_name_arabic: "م سلوت",
  },
  {
    city_name: "מסילת ציון",
    city_name_arabic: "م سالت ت سيون",
  },
  {
    city_name: "מסלול",
    city_name_arabic: "مسلول",
  },
  {
    city_name: "מסעדה",
    city_name_arabic: "مسعدة",
  },
  {
    city_name: "מסעודין אל-עזאזמה",
    city_name_arabic: "Masudin Al Azazme",
  },
  {
    city_name: "מעברות",
    city_name_arabic: "م عبروت",
  },
  {
    city_name: "מעגלים",
    city_name_arabic: "م عچليم",
  },
  {
    city_name: "מעגן",
    city_name_arabic: "معَچان",
  },
  {
    city_name: "מעגן מיכאל",
    city_name_arabic: "معَچان مي َخئيل",
  },
  {
    city_name: "מעוז חיים",
    city_name_arabic: "مع ز َحييم",
  },
  {
    city_name: "מעון",
    city_name_arabic: "معون",
  },
  {
    city_name: "מעונה",
    city_name_arabic: "معونا",
  },
  {
    city_name: "מעיליא",
    city_name_arabic: "معليا",
  },
  {
    city_name: "מעין ברוך",
    city_name_arabic: "معيان بَروخ",
  },
  {
    city_name: "מעין צבי",
    city_name_arabic: "معيان ت سڤي",
  },
  {
    city_name: "מעלה אדומים",
    city_name_arabic: "معَلي أ دميم",
  },
  {
    city_name: "מעלה אפרים",
    city_name_arabic: "معَلي إفرايم",
  },
  {
    city_name: "מעלה גלבוע",
    city_name_arabic: "معَلي َچلبووع",
  },
  {
    city_name: "מעלה גמלא",
    city_name_arabic: "معَلي چ ما",
  },
  {
    city_name: "מעלה החמישה",
    city_name_arabic: "معَلي ه َح مشا",
  },
  {
    city_name: "מעלה לבונה",
    city_name_arabic: "معَلي لڤونا",
  },
  {
    city_name: "מעלה מכמש",
    city_name_arabic: "معَلي مخماس",
  },
  {
    city_name: "מעלה עירון",
    city_name_arabic: "معَلي عيرون",
  },
  {
    city_name: "מעלה עמוס",
    city_name_arabic: "معَلي عموس",
  },
  {
    city_name: "מעלה שומרון",
    city_name_arabic: "معَلي شومرون",
  },
  {
    city_name: "מעלות-תרשיחא",
    city_name_arabic: "معَلوت ترشيحا",
  },
  {
    city_name: "מענית",
    city_name_arabic: "معَنيت",
  },
  {
    city_name: "מעש",
    city_name_arabic: "ماَعس",
  },
  {
    city_name: "מפלסים",
    city_name_arabic: "مفلسيم",
  },
  {
    city_name: "מצדות יהודה",
    city_name_arabic: "متسدوت يهودا",
  },
  {
    city_name: "מצובה",
    city_name_arabic: "متسوڤا",
  },
  {
    city_name: "מצליח",
    city_name_arabic: "متسلي َيح",
  },
  {
    city_name: "מצפה",
    city_name_arabic: "متسپي",
  },
  {
    city_name: 'מצפה אבי"ב',
    city_name_arabic: "متسپي أڤيڤ",
  },
  {
    city_name: "מצפה אילן",
    city_name_arabic: "Mitspe Ilan",
  },
  {
    city_name: "מצפה יריחו",
    city_name_arabic: "متسپي يريحو",
  },
  {
    city_name: "מצפה נטופה",
    city_name_arabic: "متسپي نتوفا",
  },
  {
    city_name: "מצפה רמון",
    city_name_arabic: "متسپي َرمون",
  },
  {
    city_name: "מצפה שלם",
    city_name_arabic: "متسپي شليم",
  },
  {
    city_name: "מצר",
    city_name_arabic: "متسار",
  },
  {
    city_name: "מקווה ישראל",
    city_name_arabic: "مكڤي يس َرئيل",
  },
  {
    city_name: "מרגליות",
    city_name_arabic: "مرچليوت",
  },
  {
    city_name: "מרום גולן",
    city_name_arabic: "مروم چولان",
  },
  {
    city_name: "מרחב עם",
    city_name_arabic: "مرحاڤ عام",
  },
  {
    city_name: "מרחביה (מושב)",
    city_name_arabic: "مرحڤيا (موشاڤ)",
  },
  {
    city_name: "מרחביה (קיבוץ)",
    city_name_arabic: "مرحڤيا (كبوتس)",
  },
  {
    city_name: "מרכז שפירא",
    city_name_arabic: "Merkaz Shappira",
  },
  {
    city_name: "משאבי שדה",
    city_name_arabic: "م شأبي َسدي",
  },
  {
    city_name: "משגב דב",
    city_name_arabic: "مسچاڤ دوڤ",
  },
  {
    city_name: "משגב עם",
    city_name_arabic: "مسچاڤ عام",
  },
  {
    city_name: "משהד",
    city_name_arabic: "مشهد",
  },
  {
    city_name: "משואה",
    city_name_arabic: "مسوؤة",
  },
  {
    city_name: "משואות יצחק",
    city_name_arabic: "َمسوؤوت  يتسحاك",
  },
  {
    city_name: "משכיות",
    city_name_arabic: "مشكيوت",
  },
  {
    city_name: "משמר איילון",
    city_name_arabic: "مشمار أ َيلون",
  },
  {
    city_name: "משמר דוד",
    city_name_arabic: "مشمار دڤيد",
  },
  {
    city_name: "משמר הירדן",
    city_name_arabic: "مشمار ه َيردين",
  },
  {
    city_name: "משמר הנגב",
    city_name_arabic: "مشمار هنيچب",
  },
  {
    city_name: "משמר העמק",
    city_name_arabic: "مشمار هعيمك",
  },
  {
    city_name: "משמר השבעה",
    city_name_arabic: "مشمار هشڤعا",
  },
  {
    city_name: "משמר השרון",
    city_name_arabic: "مشمار ه َشرون",
  },
  {
    city_name: "משמרות",
    city_name_arabic: "مشمروت",
  },
  {
    city_name: "משמרת",
    city_name_arabic: "مشميرت",
  },
  {
    city_name: "משען",
    city_name_arabic: "مشعين",
  },
  {
    city_name: "מתן",
    city_name_arabic: "متان",
  },
  {
    city_name: "מתת",
    city_name_arabic: "متات",
  },
  {
    city_name: "מתתיהו",
    city_name_arabic: "متتياهو",
  },
  {
    city_name: "נאות גולן",
    city_name_arabic: "نؤوت چولان",
  },
  {
    city_name: "נאות הכיכר",
    city_name_arabic: "نؤوت هككار",
  },
  {
    city_name: "נאות מרדכי",
    city_name_arabic: "نؤوت مردخاي",
  },
  {
    city_name: "נאות סמדר",
    city_name_arabic: "نؤوت سمدار",
  },
  {
    city_name: "נאעורה",
    city_name_arabic: "ناعورة",
  },
  {
    city_name: "נבטים",
    city_name_arabic: "نڤَتيم",
  },
  {
    city_name: "נגבה",
    city_name_arabic: "نيچبا",
  },
  {
    city_name: "נגוהות",
    city_name_arabic: "نچوهوت",
  },
  {
    city_name: "נהורה",
    city_name_arabic: "نهورا",
  },
  {
    city_name: "נהלל",
    city_name_arabic: "نهلال",
  },
  {
    city_name: "נהריה",
    city_name_arabic: "نَهريا",
  },
  {
    city_name: "נוב",
    city_name_arabic: "نوڤ",
  },
  {
    city_name: "נוגה",
    city_name_arabic: "نو َچه",
  },
  {
    city_name: "נוה צוף",
    city_name_arabic: "نڤي تسوف",
  },
  {
    city_name: "נווה",
    city_name_arabic: "Nave",
  },
  {
    city_name: "נווה אבות",
    city_name_arabic: "ن ڤي أڤوت",
  },
  {
    city_name: "נווה אור",
    city_name_arabic: "ن ڤي أور",
  },
  {
    city_name: 'נווה אטי"ב',
    city_name_arabic: "ن ڤي أتيڤ",
  },
  {
    city_name: "נווה אילן",
    city_name_arabic: "ن ڤي إيالن",
  },
  {
    city_name: "נווה איתן",
    city_name_arabic: "ن ڤي إيتان",
  },
  {
    city_name: "נווה דניאל",
    city_name_arabic: " ن ڤي دَ نيييل",
  },
  {
    city_name: "נווה זוהר",
    city_name_arabic: "نڤيزوَهر",
  },
  {
    city_name: "נווה זיו",
    city_name_arabic: "نڤي زيڤ",
  },
  {
    city_name: "נווה חריף",
    city_name_arabic: "نڤي حريف",
  },
  {
    city_name: "נווה ים",
    city_name_arabic: "نڤي يام",
  },
  {
    city_name: "נווה ימין",
    city_name_arabic: "نڤي َيمين",
  },
  {
    city_name: "נווה ירק",
    city_name_arabic: "نڤي َيراك",
  },
  {
    city_name: "נווה מבטח",
    city_name_arabic: "نڤي مڤتاح",
  },
  {
    city_name: "נווה מיכאל",
    city_name_arabic: "نڤي مي َخئيل",
  },
  {
    city_name: "נווה שלום",
    city_name_arabic: "نڤي َشلوم",
  },
  {
    city_name: "נועם",
    city_name_arabic: "نو َعم",
  },
  {
    city_name: "נוף איילון",
    city_name_arabic: "نوف أيَلون",
  },
  {
    city_name: "נוף הגליל",
    city_name_arabic: "الناصرة",
  },
  {
    city_name: "נופים",
    city_name_arabic: "نوفيم",
  },
  {
    city_name: "נופית",
    city_name_arabic: "نوفيت",
  },
  {
    city_name: "נופך",
    city_name_arabic: "نوفخ",
  },
  {
    city_name: "נוקדים",
    city_name_arabic: "نوكديم",
  },
  {
    city_name: "נורדיה",
    city_name_arabic: "نورديا",
  },
  {
    city_name: "נורית",
    city_name_arabic: "نوريت",
  },
  {
    city_name: "נחושה",
    city_name_arabic: "نحوشا",
  },
  {
    city_name: "נחל עוז",
    city_name_arabic: "نا َحل عوز",
  },
  {
    city_name: "נחלה",
    city_name_arabic: "ن َحلا",
  },
  {
    city_name: "נחליאל",
    city_name_arabic: "نحليئيل",
  },
  {
    city_name: "נחלים",
    city_name_arabic: "ن َحليم",
  },
  {
    city_name: "נחם",
    city_name_arabic: "نا َحم",
  },
  {
    city_name: "נחף",
    city_name_arabic: "نحف",
  },
  {
    city_name: "נחשולים",
    city_name_arabic: "نحشوليم",
  },
  {
    city_name: "נחשון",
    city_name_arabic: "نحشون",
  },
  {
    city_name: "נחשונים",
    city_name_arabic: "نحشونيم",
  },
  {
    city_name: "נטועה",
    city_name_arabic: "نتوَعا",
  },
  {
    city_name: "נטור",
    city_name_arabic: "نتور",
  },
  {
    city_name: "נטע",
    city_name_arabic: "Neta",
  },
  {
    city_name: "נטעים",
    city_name_arabic: "ن تَعيم",
  },
  {
    city_name: "נטף",
    city_name_arabic: "نَتاف",
  },
  {
    city_name: "ניין",
    city_name_arabic: "نين",
  },
  {
    city_name: 'ניל"י',
    city_name_arabic: "نيلي",
  },
  {
    city_name: "ניצן",
    city_name_arabic: "نتسان",
  },
  {
    city_name: "ניצן ב'",
    city_name_arabic: "نتسان",
  },
  {
    city_name: "ניצנה (קהילת חינוך)",
    city_name_arabic: "نتسانا",
  },
  {
    city_name: "ניצני סיני",
    city_name_arabic: "َنتسني سيناي",
  },
  {
    city_name: "ניצני עוז",
    city_name_arabic: "نت َسني عوز",
  },
  {
    city_name: "ניצנים",
    city_name_arabic: "نتسنيم",
  },
  {
    city_name: "ניר אליהו",
    city_name_arabic: "نير إلياهو",
  },
  {
    city_name: "ניר בנים",
    city_name_arabic: "نير بنيم",
  },
  {
    city_name: "ניר גלים",
    city_name_arabic: "نير چليم",
  },
  {
    city_name: "ניר דוד (תל עמל)",
    city_name_arabic: "Nir David",
  },
  {
    city_name: 'ניר ח"ן',
    city_name_arabic: "نير حين",
  },
  {
    city_name: "ניר יפה",
    city_name_arabic: "نير َيفي",
  },
  {
    city_name: "ניר יצחק",
    city_name_arabic: "نير يتسحاك",
  },
  {
    city_name: "ניר ישראל",
    city_name_arabic: "نير يسرئيل",
  },
  {
    city_name: "ניר משה",
    city_name_arabic: "نير موشي",
  },
  {
    city_name: "ניר עוז",
    city_name_arabic: "نير عوز",
  },
  {
    city_name: "ניר עם",
    city_name_arabic: "نير عام",
  },
  {
    city_name: "ניר עציון",
    city_name_arabic: "نير عتسيون",
  },
  {
    city_name: "ניר עקיבא",
    city_name_arabic: "نير عكيڤا",
  },
  {
    city_name: "ניר צבי",
    city_name_arabic: "نير تسڤي",
  },
  {
    city_name: "נירים",
    city_name_arabic: "نيريم",
  },
  {
    city_name: "נירית",
    city_name_arabic: "نيريت",
  },
  {
    city_name: "נמרוד",
    city_name_arabic: "نمرود",
  },
  {
    city_name: "נס הרים",
    city_name_arabic: "نيس هريم",
  },
  {
    city_name: "נס עמים",
    city_name_arabic: "نيس عميم",
  },
  {
    city_name: "נס ציונה",
    city_name_arabic: "نيس تسيونا",
  },
  {
    city_name: "נעורים",
    city_name_arabic: "نعوريم",
  },
  {
    city_name: "נעלה",
    city_name_arabic: "نعلي",
  },
  {
    city_name: 'נעמ"ה',
    city_name_arabic: "ن َعما",
  },
  {
    city_name: "נען",
    city_name_arabic: "ناَعن",
  },
  {
    city_name: "נערן",
    city_name_arabic: "Na’aran",
  },
  {
    city_name: "נצאצרה (שבט)",
    city_name_arabic: "Nasasra",
  },
  {
    city_name: "נצר חזני",
    city_name_arabic: "Netser Hazani",
  },
  {
    city_name: "נצר סרני",
    city_name_arabic: "نيتسر سراني",
  },
  {
    city_name: "נצרת",
    city_name_arabic: "الناصرة",
  },
  {
    city_name: "נשר",
    city_name_arabic: "نيشر",
  },
  {
    city_name: "נתיב הגדוד",
    city_name_arabic: "ن تيڤ ه چدود",
  },
  {
    city_name: 'נתיב הל"ה',
    city_name_arabic: "ن تيڤ هال مد هي",
  },
  {
    city_name: "נתיב העשרה",
    city_name_arabic: "ن تيڤ هع َسرا",
  },
  {
    city_name: "נתיב השיירה",
    city_name_arabic: "ن تيڤ هشَ يَرا",
  },
  {
    city_name: "נתיבות",
    city_name_arabic: "نتيڤوت",
  },
  {
    city_name: "נתניה",
    city_name_arabic: "نتنيا",
  },
  {
    city_name: "סאג'ור",
    city_name_arabic: "ساجور",
  },
  {
    city_name: "סאסא",
    city_name_arabic: "ساسا",
  },
  {
    city_name: "סביון",
    city_name_arabic: "سڤيون",
  },
  {
    city_name: "סגולה",
    city_name_arabic: "سچلا",
  },
  {
    city_name: "סואעד (חמרייה)",
    city_name_arabic: "سواعد",
  },
  {
    city_name: "סואעד (כמאנה) (שבט)",
    city_name_arabic: "سواعد",
  },
  {
    city_name: "סולם",
    city_name_arabic: "سولم",
  },
  {
    city_name: "סוסיה",
    city_name_arabic: "سوسيا",
  },
  {
    city_name: "סופה",
    city_name_arabic: "سوفا",
  },
  {
    city_name: "סח'נין",
    city_name_arabic: "سخنين",
  },
  {
    city_name: "סייד (שבט)",
    city_name_arabic: "Sayid",
  },
  {
    city_name: "סלמה",
    city_name_arabic: "سلمة",
  },
  {
    city_name: "סלעית",
    city_name_arabic: "سلعيت",
  },
  {
    city_name: "סמר",
    city_name_arabic: "سمار",
  },
  {
    city_name: "סנסנה",
    city_name_arabic: "س نسنا",
  },
  {
    city_name: "סעד",
    city_name_arabic: "ساعَد",
  },
  {
    city_name: "סעוה",
    city_name_arabic: "Sawa",
  },
  {
    city_name: "סער",
    city_name_arabic: "ساعَر",
  },
  {
    city_name: "ספיר",
    city_name_arabic: "سپير",
  },
  {
    city_name: "סתריה",
    city_name_arabic: "ستريا",
  },
  {
    city_name: "ע'ג'ר",
    city_name_arabic: "Ghajar",
  },
  {
    city_name: "עבדון",
    city_name_arabic: "عڤدون",
  },
  {
    city_name: "עברון",
    city_name_arabic: "عڤرون",
  },
  {
    city_name: "עגור",
    city_name_arabic: "عچور",
  },
  {
    city_name: "עדי",
    city_name_arabic: "عدي",
  },
  {
    city_name: "עדנים",
    city_name_arabic: "عَدنيم",
  },
  {
    city_name: "עוזה",
    city_name_arabic: "عزا",
  },
  {
    city_name: "עוזייר",
    city_name_arabic: "عزير",
  },
  {
    city_name: "עולש",
    city_name_arabic: "عولش",
  },
  {
    city_name: "עומר",
    city_name_arabic: "عومر",
  },
  {
    city_name: "עופר",
    city_name_arabic: "عوفر",
  },
  {
    city_name: "עופרה",
    city_name_arabic: "ُعفرا",
  },
  {
    city_name: "עוצם",
    city_name_arabic: "عوتسم",
  },
  {
    city_name: "עוקבי (בנו עוקבה)",
    city_name_arabic: "Uqbi",
  },
  {
    city_name: "עזוז",
    city_name_arabic: "عزوز",
  },
  {
    city_name: "עזר",
    city_name_arabic: "عيزر",
  },
  {
    city_name: "עזריאל",
    city_name_arabic: "عزريئيل",
  },
  {
    city_name: "עזריה",
    city_name_arabic: "عزريا",
  },
  {
    city_name: "עזריקם",
    city_name_arabic: "عزريكام",
  },
  {
    city_name: "עטאוונה (שבט)",
    city_name_arabic: "Atawne",
  },
  {
    city_name: "עטרת",
    city_name_arabic: "عتيرت",
  },
  {
    city_name: "עידן",
    city_name_arabic: "عدان",
  },
  {
    city_name: "עיילבון",
    city_name_arabic: "عيلبون",
  },
  {
    city_name: "עיינות",
    city_name_arabic: "ع َينوت",
  },
  {
    city_name: "עילוט",
    city_name_arabic: "عيلوط",
  },
  {
    city_name: "עין איילה",
    city_name_arabic: "عين أ َيلا",
  },
  {
    city_name: "עין אל-אסד",
    city_name_arabic: "عين الاسد",
  },
  {
    city_name: "עין גב",
    city_name_arabic: "عين چيڤ",
  },
  {
    city_name: "עין גדי",
    city_name_arabic: "عين چيدي",
  },
  {
    city_name: "עין דור",
    city_name_arabic: "عين دور  ",
  },
  {
    city_name: "עין הבשור",
    city_name_arabic: "عين هبسور",
  },
  {
    city_name: "עין הוד",
    city_name_arabic: "عين هود",
  },
  {
    city_name: "עין החורש",
    city_name_arabic: "عين هحوريش",
  },
  {
    city_name: "עין המפרץ",
    city_name_arabic: "عين همفراتس",
  },
  {
    city_name: 'עין הנצי"ב',
    city_name_arabic: "عين هنتسيڤ",
  },
  {
    city_name: "עין העמק",
    city_name_arabic: "عين عيمك",
  },
  {
    city_name: "עין השופט",
    city_name_arabic: "عين هشوفيت",
  },
  {
    city_name: "עין השלושה",
    city_name_arabic: "عين َهشلوشا",
  },
  {
    city_name: "עין ורד",
    city_name_arabic: "عين ڤيرد",
  },
  {
    city_name: "עין זיוון",
    city_name_arabic: "عين زيڤان",
  },
  {
    city_name: "עין חוד",
    city_name_arabic: "عين حوض",
  },
  {
    city_name: "עין חצבה",
    city_name_arabic: "عين حتسڤا",
  },
  {
    city_name: "עין חרוד (איחוד)",
    city_name_arabic: "عين حرود (إيحود)",
  },
  {
    city_name: "עין חרוד (מאוחד)",
    city_name_arabic: "عين حرود (مؤوحاد)",
  },
  {
    city_name: "עין יהב",
    city_name_arabic: "عين يا َهڤ",
  },
  {
    city_name: "עין יעקב",
    city_name_arabic: "عين ي َعكوڤ",
  },
  {
    city_name: 'עין כרם-בי"ס חקלאי',
    city_name_arabic: "EN KAREM-B.S.HAQLA'I",
  },
  {
    city_name: "עין כרמל",
    city_name_arabic: "عين كرميل",
  },
  {
    city_name: "עין מאהל",
    city_name_arabic: "عين ماهل",
  },
  {
    city_name: "עין נקובא",
    city_name_arabic: "عين نقوبا",
  },
  {
    city_name: "עין עירון",
    city_name_arabic: "عين عيرون",
  },
  {
    city_name: "עין צורים",
    city_name_arabic: "عين تسوريم",
  },
  {
    city_name: "עין קנייא",
    city_name_arabic: "عين قنية",
  },
  {
    city_name: "עין ראפה",
    city_name_arabic: "عين رافة",
  },
  {
    city_name: "עין שמר",
    city_name_arabic: "عين شيمر",
  },
  {
    city_name: "עין שריד",
    city_name_arabic: "عين سريد",
  },
  {
    city_name: "עין תמר",
    city_name_arabic: "عين تمار",
  },
  {
    city_name: "עינת",
    city_name_arabic: "عينات",
  },
  {
    city_name: "עיר אובות",
    city_name_arabic: "عير أوڤوت",
  },
  {
    city_name: "עכו",
    city_name_arabic: "عكو",
  },
  {
    city_name: "עלומים",
    city_name_arabic: "علوميم",
  },
  {
    city_name: "עלי",
    city_name_arabic: "علي",
  },
  {
    city_name: "עלי זהב",
    city_name_arabic: "عَ لي زهاڤ",
  },
  {
    city_name: "עלמה",
    city_name_arabic: "علما",
  },
  {
    city_name: "עלמון",
    city_name_arabic: "علمون",
  },
  {
    city_name: "עמוקה",
    city_name_arabic: "عمكا",
  },
  {
    city_name: "עמיחי",
    city_name_arabic: "Amihay",
  },
  {
    city_name: "עמינדב",
    city_name_arabic: "عمينَداڤ",
  },
  {
    city_name: "עמיעד",
    city_name_arabic: "عميعاد",
  },
  {
    city_name: "עמיעוז",
    city_name_arabic: "عميعوز",
  },
  {
    city_name: "עמיקם",
    city_name_arabic: "عميكام",
  },
  {
    city_name: "עמיר",
    city_name_arabic: "عمير",
  },
  {
    city_name: "עמנואל",
    city_name_arabic: "ع َمنوئيل",
  },
  {
    city_name: "עמקה",
    city_name_arabic: "عمكا",
  },
  {
    city_name: "ענב",
    city_name_arabic: "عناڤ",
  },
  {
    city_name: "עספיא",
    city_name_arabic: "Isifya",
  },
  {
    city_name: "עפולה",
    city_name_arabic: "عَفوال",
  },
  {
    city_name: "עץ אפרים",
    city_name_arabic: "عيتس إفرايم",
  },
  {
    city_name: "עצמון שגב",
    city_name_arabic: "Atsmon Negev",
  },
  {
    city_name: "עראבה",
    city_name_arabic: "عرابة",
  },
  {
    city_name: "עראמשה",
    city_name_arabic: "عرامشة",
  },
  {
    city_name: "ערב אל נעים",
    city_name_arabic: "عرب ألنعيم",
  },
  {
    city_name: "ערד",
    city_name_arabic: "عراد",
  },
  {
    city_name: "ערוגות",
    city_name_arabic: "عروچوت",
  },
  {
    city_name: "ערערה",
    city_name_arabic: "عرعرة",
  },
  {
    city_name: "ערערה-בנגב",
    city_name_arabic: "عرعرة–في النقب",
  },
  {
    city_name: "עשרת",
    city_name_arabic: "عسيرت",
  },
  {
    city_name: "עתלית",
    city_name_arabic: "عت ليت",
  },
  {
    city_name: "עתניאל",
    city_name_arabic: "عتنيئيل",
  },
  {
    city_name: "פארן",
    city_name_arabic: "پاران",
  },
  {
    city_name: "פדואל",
    city_name_arabic: "پدوئيل",
  },
  {
    city_name: "פדויים",
    city_name_arabic: "پدوييم",
  },
  {
    city_name: "פדיה",
    city_name_arabic: "پدَ يا",
  },
  {
    city_name: "פוריה - כפר עבודה",
    city_name_arabic: "پو ريا – كفار عڤودا",
  },
  {
    city_name: "פוריה - נווה עובד",
    city_name_arabic: "پو ريا – نڤي عوڤيد",
  },
  {
    city_name: "פוריה עילית",
    city_name_arabic: "پو ريا عليت",
  },
  {
    city_name: "פוריידיס",
    city_name_arabic: "فريديس",
  },
  {
    city_name: "פורת",
    city_name_arabic: "پورات",
  },
  {
    city_name: "פטיש",
    city_name_arabic: "پتيش",
  },
  {
    city_name: "פלך",
    city_name_arabic: "پي لخ",
  },
  {
    city_name: "פלמחים",
    city_name_arabic: "پلمحيم",
  },
  {
    city_name: "פני חבר",
    city_name_arabic: "پني حي ڤر",
  },
  {
    city_name: "פסגות",
    city_name_arabic: "پسچوت",
  },
  {
    city_name: "פסוטה",
    city_name_arabic: "فسوطة",
  },
  {
    city_name: 'פעמי תש"ז',
    city_name_arabic: "پعَمي تَشاز",
  },
  {
    city_name: "פצאל",
    city_name_arabic: "َپتسئيل",
  },
  {
    city_name: "פקיעין (בוקייעה)",
    city_name_arabic: "پكيعين",
  },
  {
    city_name: "פקיעין חדשה",
    city_name_arabic: "پكيعينهحَدشا",
  },
  {
    city_name: "פרדס חנה-כרכור",
    city_name_arabic: "پرديس َحنا – كركور",
  },
  {
    city_name: "פרדסיה",
    city_name_arabic: "پردسيا",
  },
  {
    city_name: "פרוד",
    city_name_arabic: "پرود",
  },
  {
    city_name: "פרזון",
    city_name_arabic: "پ َرزون",
  },
  {
    city_name: "פרי גן",
    city_name_arabic: "پري چان",
  },
  {
    city_name: "פתח תקווה",
    city_name_arabic: "پي َت َِح تكڤا",
  },
  {
    city_name: "פתחיה",
    city_name_arabic: "پتَحيا",
  },
  {
    city_name: "צאלים",
    city_name_arabic: "تسئليم",
  },
  {
    city_name: "צביה",
    city_name_arabic: "تسڤيا",
  },
  {
    city_name: "צבעון",
    city_name_arabic: "تسڤعون",
  },
  {
    city_name: "צובה",
    city_name_arabic: "تسوڤا",
  },
  {
    city_name: "צוחר",
    city_name_arabic: "تسو َحر",
  },
  {
    city_name: "צופיה",
    city_name_arabic: "تسوفيا",
  },
  {
    city_name: "צופים",
    city_name_arabic: "تسوفيم",
  },
  {
    city_name: "צופית",
    city_name_arabic: "تسوفيت",
  },
  {
    city_name: "צופר",
    city_name_arabic: "تسوفار",
  },
  {
    city_name: "צוקי ים",
    city_name_arabic: "تسوكي يام",
  },
  {
    city_name: "צוקים",
    city_name_arabic: "تسوكيم",
  },
  {
    city_name: "צור הדסה",
    city_name_arabic: "تسور ه َدسا",
  },
  {
    city_name: "צור יצחק",
    city_name_arabic: "تسور يتسحاك",
  },
  {
    city_name: "צור משה",
    city_name_arabic: "تسور موشي",
  },
  {
    city_name: "צור נתן",
    city_name_arabic: "تسور نَتان",
  },
  {
    city_name: "צוריאל",
    city_name_arabic: "تسوريئيل",
  },
  {
    city_name: "צורית",
    city_name_arabic: "تسوريت",
  },
  {
    city_name: "ציפורי",
    city_name_arabic: "ت سپوري",
  },
  {
    city_name: "צלפון",
    city_name_arabic: "ت سلَفون",
  },
  {
    city_name: "צנדלה",
    city_name_arabic: "صندلة",
  },
  {
    city_name: "צפריה",
    city_name_arabic: "ت َسفَريا",
  },
  {
    city_name: "צפרירים",
    city_name_arabic: "ت َسفريريم",
  },
  {
    city_name: "צפת",
    city_name_arabic: "تسفات",
  },
  {
    city_name: "צרופה",
    city_name_arabic: "تسروفا",
  },
  {
    city_name: "צרעה",
    city_name_arabic: "تسرعا",
  },
  {
    city_name: "קבועה (שבט)",
    city_name_arabic: "Qabo'a",
  },
  {
    city_name: "קבוצת יבנה",
    city_name_arabic: "كڤوتسات يڤني",
  },
  {
    city_name: "קדומים",
    city_name_arabic: "كدوميم",
  },
  {
    city_name: "קדימה-צורן",
    city_name_arabic: "كدي َما",
  },
  {
    city_name: "קדמה",
    city_name_arabic: "كيدما",
  },
  {
    city_name: "קדמת צבי",
    city_name_arabic: "كدمات تسڤي",
  },
  {
    city_name: "קדר",
    city_name_arabic: "كدار",
  },
  {
    city_name: "קדרון",
    city_name_arabic: "كدرون",
  },
  {
    city_name: "קדרים",
    city_name_arabic: "َكدَريم",
  },
  {
    city_name: "קודייראת א-צאנע(שבט)",
    city_name_arabic: "Qudeirat As Sani",
  },
  {
    city_name: "קוואעין (שבט)",
    city_name_arabic: "Qawain",
  },
  {
    city_name: "קוממיות",
    city_name_arabic: "كومميوت",
  },
  {
    city_name: "קורנית",
    city_name_arabic: "كو َرنيت",
  },
  {
    city_name: "קטורה",
    city_name_arabic: "كتورا",
  },
  {
    city_name: "קיסריה",
    city_name_arabic: "كي َسريا",
  },
  {
    city_name: "קלחים",
    city_name_arabic: "كلَحيم",
  },
  {
    city_name: "קליה",
    city_name_arabic: "كاليا",
  },
  {
    city_name: "קלנסווה",
    city_name_arabic: "قلنسوة",
  },
  {
    city_name: "קלע",
    city_name_arabic: "كيلَع",
  },
  {
    city_name: "קציר",
    city_name_arabic: "كتسير– حريش",
  },
  {
    city_name: "קצר א-סר",
    city_name_arabic: "قصر السر",
  },
  {
    city_name: "קצרין",
    city_name_arabic: "كتسرين",
  },
  {
    city_name: "קרית אונו",
    city_name_arabic: "كريات أونو",
  },
  {
    city_name: "קרית ארבע",
    city_name_arabic: "كريات أرباع",
  },
  {
    city_name: "קרית אתא",
    city_name_arabic: "كريات آتا",
  },
  {
    city_name: "קרית ביאליק",
    city_name_arabic: "كريات بياليك",
  },
  {
    city_name: "קרית גת",
    city_name_arabic: "كريات چات",
  },
  {
    city_name: "קרית טבעון",
    city_name_arabic: "كريات تڤعون",
  },
  {
    city_name: "קרית ים",
    city_name_arabic: "كريات يام",
  },
  {
    city_name: "קרית יערים",
    city_name_arabic: "كريات ي َعريم;",
  },
  {
    city_name: "קרית יערים(מוסד)",
    city_name_arabic: "كريات ي َعريم;",
  },
  {
    city_name: "קרית מוצקין",
    city_name_arabic: "كريات موتسكين",
  },
  {
    city_name: "קרית מלאכי",
    city_name_arabic: "كريات ملأخي",
  },
  {
    city_name: "קרית נטפים",
    city_name_arabic: "كريات نتفيم",
  },
  {
    city_name: "קרית ענבים",
    city_name_arabic: "كريات ع َنڤيم",
  },
  {
    city_name: "קרית עקרון",
    city_name_arabic: "كريات عكرون",
  },
  {
    city_name: "קרית שלמה",
    city_name_arabic: "كريات شلومو",
  },
  {
    city_name: "קרית שמונה",
    city_name_arabic: "كريات شمونا",
  },
  {
    city_name: "קרני שומרון",
    city_name_arabic: "كرني شومرون",
  },
  {
    city_name: "קשת",
    city_name_arabic: "كيشت",
  },
  {
    city_name: "ראמה",
    city_name_arabic: "رامة",
  },
  {
    city_name: "ראס אל-עין",
    city_name_arabic: "رأس العين",
  },
  {
    city_name: "ראס עלי",
    city_name_arabic: "رأس علي",
  },
  {
    city_name: "ראש העין",
    city_name_arabic: "روش هعاين",
  },
  {
    city_name: "ראש פינה",
    city_name_arabic: "روش پينا",
  },
  {
    city_name: "ראש צורים",
    city_name_arabic: "روش تسوريم",
  },
  {
    city_name: "ראשון לציון",
    city_name_arabic: "ريشون لتسيون",
  },
  {
    city_name: "רבבה",
    city_name_arabic: "رڤَڤا",
  },
  {
    city_name: "רבדים",
    city_name_arabic: "رڤديم",
  },
  {
    city_name: "רביבים",
    city_name_arabic: "رڤيڤيم",
  },
  {
    city_name: "רביד",
    city_name_arabic: "رڤيد",
  },
  {
    city_name: "רגבה",
    city_name_arabic: "ريچبا",
  },
  {
    city_name: "רגבים",
    city_name_arabic: "ر َچڤيم",
  },
  {
    city_name: "רהט",
    city_name_arabic: "رهط",
  },
  {
    city_name: "רווחה",
    city_name_arabic: "رڤحا",
  },
  {
    city_name: "רוויה",
    city_name_arabic: "رڤَيا",
  },
  {
    city_name: "רוח מדבר",
    city_name_arabic: " رو َوح مدبار",
  },
  {
    city_name: "רוחמה",
    city_name_arabic: "رحاما",
  },
  {
    city_name: "רומאנה",
    city_name_arabic: "رمانة",
  },
  {
    city_name: "רומת הייב",
    city_name_arabic: "رمة الهيب",
  },
  {
    city_name: "רועי",
    city_name_arabic: "روعي",
  },
  {
    city_name: "רותם",
    city_name_arabic: "روت",
  },
  {
    city_name: "רחוב",
    city_name_arabic: "رحوڤ",
  },
  {
    city_name: "רחובות",
    city_name_arabic: "رحوڤوت",
  },
  {
    city_name: "רחלים",
    city_name_arabic: "Rehelim",
  },
  {
    city_name: "ריחאניה",
    city_name_arabic: "ريحانية",
  },
  {
    city_name: "ריחן",
    city_name_arabic: "ريحان",
  },
  {
    city_name: "ריינה",
    city_name_arabic: "رينة",
  },
  {
    city_name: "רימונים",
    city_name_arabic: "رمونيم",
  },
  {
    city_name: "רינתיה",
    city_name_arabic: "رنت يا",
  },
  {
    city_name: "רכסים",
    city_name_arabic: "ر َخسيم",
  },
  {
    city_name: "רם-און",
    city_name_arabic: "رام أون",
  },
  {
    city_name: "רמות",
    city_name_arabic: "رموت",
  },
  {
    city_name: "רמות השבים",
    city_name_arabic: "رموت هشَ ڤيم",
  },
  {
    city_name: "רמות מאיר",
    city_name_arabic: "رموت مئي",
  },
  {
    city_name: "רמות מנשה",
    city_name_arabic: "رموت منَشي",
  },
  {
    city_name: "רמות נפתלי",
    city_name_arabic: "رموت ن فتلي",
  },
  {
    city_name: "רמלה",
    city_name_arabic: "رملة",
  },
  {
    city_name: "רמת גן",
    city_name_arabic: "رمات چان",
  },
  {
    city_name: "רמת דוד",
    city_name_arabic: "رمات دڤيد",
  },
  {
    city_name: "רמת הכובש",
    city_name_arabic: "رمات هكوڤيش",
  },
  {
    city_name: "רמת השופט",
    city_name_arabic: "رمات هشوفيت",
  },
  {
    city_name: "רמת השרון",
    city_name_arabic: "رمات هشَرون",
  },
  {
    city_name: "רמת יוחנן",
    city_name_arabic: "رمات يوحنان",
  },
  {
    city_name: "רמת ישי",
    city_name_arabic: "رمات يشاي",
  },
  {
    city_name: "רמת מגשימים",
    city_name_arabic: "رمات مچشيميم",
  },
  {
    city_name: "רמת צבי",
    city_name_arabic: "رمات ت سڤي",
  },
  {
    city_name: "רמת רזיאל",
    city_name_arabic: "رمات رزيئيل",
  },
  {
    city_name: "רמת רחל",
    city_name_arabic: "رمات َرحيل",
  },
  {
    city_name: "רנן",
    city_name_arabic: "َرنين",
  },
  {
    city_name: "רעים",
    city_name_arabic: "رعيم",
  },
  {
    city_name: "רעננה",
    city_name_arabic: "رَعننا",
  },
  {
    city_name: "רקפת",
    city_name_arabic: "ركيفت",
  },
  {
    city_name: "רשפון",
    city_name_arabic: "رشپون",
  },
  {
    city_name: "רשפים",
    city_name_arabic: "ر َشفيم",
  },
  {
    city_name: "רתמים",
    city_name_arabic: "Retamim",
  },
  {
    city_name: "שאר ישוב",
    city_name_arabic: "شآر يشوڤ",
  },
  {
    city_name: "שבי דרום",
    city_name_arabic: "Shave Darom",
  },
  {
    city_name: "שבי ציון",
    city_name_arabic: "شڤي تسيون",
  },
  {
    city_name: "שבי שומרון",
    city_name_arabic: "شڤي شومرون",
  },
  {
    city_name: "שבלי - אום אל-גנם",
    city_name_arabic: "الشبلي - أم الغنم",
  },
  {
    city_name: "שגב-שלום",
    city_name_arabic: "شقيب شلوم",
  },
  {
    city_name: "שדה אילן",
    city_name_arabic: "سدي إيلان",
  },
  {
    city_name: "שדה אליהו",
    city_name_arabic: "سدي إلياهو",
  },
  {
    city_name: "שדה אליעזר",
    city_name_arabic: "سدي إليعيزر",
  },
  {
    city_name: "שדה בוקר",
    city_name_arabic: "سدي بوكير",
  },
  {
    city_name: "שדה דוד",
    city_name_arabic: "سدي دڤيد",
  },
  {
    city_name: "שדה ורבורג",
    city_name_arabic: "سدي ڤاربورچ",
  },
  {
    city_name: "שדה יואב",
    city_name_arabic: "سدي يوآڤ",
  },
  {
    city_name: "שדה יעקב",
    city_name_arabic: "سدي ي َعكوڤ",
  },
  {
    city_name: "שדה יצחק",
    city_name_arabic: "سدي يتسحاك",
  },
  {
    city_name: "שדה משה",
    city_name_arabic: "سدي موشي",
  },
  {
    city_name: "שדה נחום",
    city_name_arabic: "سدي نحوم",
  },
  {
    city_name: "שדה נחמיה",
    city_name_arabic: "سدي نحميا",
  },
  {
    city_name: "שדה ניצן",
    city_name_arabic: "سدي نتسان",
  },
  {
    city_name: "שדה עוזיהו",
    city_name_arabic: "سدي عزياهو",
  },
  {
    city_name: "שדה צבי",
    city_name_arabic: "سدي تسڤي",
  },
  {
    city_name: "שדות ים",
    city_name_arabic: "سدوت يام",
  },
  {
    city_name: "שדות מיכה",
    city_name_arabic: "سدوت ميخا",
  },
  {
    city_name: "שדי אברהם",
    city_name_arabic: "سدوت أڤ َرهام",
  },
  {
    city_name: "שדי חמד",
    city_name_arabic: "سدي حيمد",
  },
  {
    city_name: "שדי תרומות",
    city_name_arabic: "سدي تروموت",
  },
  {
    city_name: "שדמה",
    city_name_arabic: "شدما",
  },
  {
    city_name: "שדמות דבורה",
    city_name_arabic: "شدموت دڤورا",
  },
  {
    city_name: "שדמות מחולה",
    city_name_arabic: "شدموت محولا",
  },
  {
    city_name: "שדרות",
    city_name_arabic: "سدروت",
  },
  {
    city_name: "שואבה",
    city_name_arabic: "شوئڤا",
  },
  {
    city_name: "שובה",
    city_name_arabic: "شوڤا",
  },
  {
    city_name: "שובל",
    city_name_arabic: "شوڤال",
  },
  {
    city_name: "שוהם",
    city_name_arabic: "شو َهم",
  },
  {
    city_name: "שומרה",
    city_name_arabic: "شومرا",
  },
  {
    city_name: "שומריה",
    city_name_arabic: "شومريا",
  },
  {
    city_name: "שוקדה",
    city_name_arabic: "شوكدا",
  },
  {
    city_name: "שורש",
    city_name_arabic: "شورش",
  },
  {
    city_name: "שורשים",
    city_name_arabic: "ش َرشيم",
  },
  {
    city_name: "שושנת העמקים",
    city_name_arabic: "شو َشناتهعَمكيم",
  },
  {
    city_name: "שזור",
    city_name_arabic: "شزور",
  },
  {
    city_name: "שחר",
    city_name_arabic: "شا َحر",
  },
  {
    city_name: "שחרות",
    city_name_arabic: "ش َحروت",
  },
  {
    city_name: "שיבולים",
    city_name_arabic: "شبوليم",
  },
  {
    city_name: "שיטים",
    city_name_arabic: "شتيم",
  },
  {
    city_name: "שייח' דנון",
    city_name_arabic: "شيخ دنون",
  },
  {
    city_name: "שילה",
    city_name_arabic: "شيلو",
  },
  {
    city_name: "שילת",
    city_name_arabic: "شيالت",
  },
  {
    city_name: "שכניה",
    city_name_arabic: "ش َخنيا",
  },
  {
    city_name: "שלווה",
    city_name_arabic: "شَلڤا",
  },
  {
    city_name: "שלווה במדבר",
    city_name_arabic: "Shalva BaMidbar",
  },
  {
    city_name: "שלוחות",
    city_name_arabic: "شلوحوت",
  },
  {
    city_name: "שלומי",
    city_name_arabic: "شلومي",
  },
  {
    city_name: "שלומית",
    city_name_arabic: "Shlomit",
  },
  {
    city_name: "שמיר",
    city_name_arabic: "ش مير",
  },
  {
    city_name: "שמעה",
    city_name_arabic: "شمعا",
  },
  {
    city_name: "שמרת",
    city_name_arabic: "شومرات",
  },
  {
    city_name: "שמשית",
    city_name_arabic: "شمشيت",
  },
  {
    city_name: "שני",
    city_name_arabic: "شَني",
  },
  {
    city_name: "שניר",
    city_name_arabic: "سنير",
  },
  {
    city_name: "שעב",
    city_name_arabic: "شعب",
  },
  {
    city_name: "שעורים",
    city_name_arabic: "Se'orim",
  },
  {
    city_name: "שעל",
    city_name_arabic: "شاَعل",
  },
  {
    city_name: "שעלבים",
    city_name_arabic: "ش َعلڤيم",
  },
  {
    city_name: "שער אפרים",
    city_name_arabic: "شاَعرإفرايم",
  },
  {
    city_name: "שער הגולן",
    city_name_arabic: "شا َعر هچولان",
  },
  {
    city_name: "שער העמקים",
    city_name_arabic: "شاَعرعَمكيم",
  },
  {
    city_name: "שער מנשה",
    city_name_arabic: "شا َعر منشي",
  },
  {
    city_name: "שערי תקווה",
    city_name_arabic: "ش َعري تكڤا",
  },
  {
    city_name: "שפיים",
    city_name_arabic: "شفير",
  },
  {
    city_name: "שפיר",
    city_name_arabic: "شفير",
  },
  {
    city_name: "שפר",
    city_name_arabic: "شيفر",
  },
  {
    city_name: "שפרעם",
    city_name_arabic: "Shefar'am",
  },
  {
    city_name: "שקד",
    city_name_arabic: "شكيد",
  },
  {
    city_name: "שקף",
    city_name_arabic: "شيكف",
  },
  {
    city_name: "שרונה",
    city_name_arabic: "شرونا",
  },
  {
    city_name: "שריגים (לי-און)",
    city_name_arabic: "شريچيم (لي-أون)",
  },
  {
    city_name: "שריד",
    city_name_arabic: "سريد",
  },
  {
    city_name: "שרשרת",
    city_name_arabic: "شرشيرت",
  },
  {
    city_name: "שתולה",
    city_name_arabic: "شتولا",
  },
  {
    city_name: "שתולים",
    city_name_arabic: "شتوليم",
  },
  {
    city_name: "תאשור",
    city_name_arabic: "تأشور",
  },
  {
    city_name: "תדהר",
    city_name_arabic: "تدهار",
  },
  {
    city_name: "תובל",
    city_name_arabic: "توڤال",
  },
  {
    city_name: "תומר",
    city_name_arabic: "تومر",
  },
  {
    city_name: "תושיה",
    city_name_arabic: "توشيا",
  },
  {
    city_name: "תימורים",
    city_name_arabic: "ت موريم",
  },
  {
    city_name: "תירוש",
    city_name_arabic: "تيروش",
  },
  {
    city_name: "תל אביב - יפו",
    city_name_arabic: "تل أڤيڤ – يافو",
  },
  {
    city_name: "תל יוסף",
    city_name_arabic: "تيل يوسيف",
  },
  {
    city_name: "תל יצחק",
    city_name_arabic: "تيل  يتسحاك",
  },
  {
    city_name: "תל מונד",
    city_name_arabic: "تيل مو ند",
  },
  {
    city_name: "תל עדשים",
    city_name_arabic: "تلعَدشيم",
  },
  {
    city_name: "תל קציר",
    city_name_arabic: "تيل كت سير",
  },
  {
    city_name: "תל שבע",
    city_name_arabic: "تيل شيڤع",
  },
  {
    city_name: "תל תאומים",
    city_name_arabic: "تيل ت ؤوميم",
  },
  {
    city_name: "תלם",
    city_name_arabic: "تي لم",
  },
  {
    city_name: "תלמי אליהו",
    city_name_arabic: "تلمي إلياهو",
  },
  {
    city_name: "תלמי אלעזר",
    city_name_arabic: "تلمي إليعيزر",
  },
  {
    city_name: 'תלמי ביל"ו',
    city_name_arabic: "تلمي بيلو",
  },
  {
    city_name: "תלמי יוסף",
    city_name_arabic: "تلمي يوسيف",
  },
  {
    city_name: "תלמי יחיאל",
    city_name_arabic: "تلمي يحيئيل",
  },
  {
    city_name: "תלמי יפה",
    city_name_arabic: "تلمي يفي",
  },
  {
    city_name: "תלמים",
    city_name_arabic: "ت لميم",
  },
  {
    city_name: "תמרת",
    city_name_arabic: "ت َِمرات",
  },
  {
    city_name: "תנובות",
    city_name_arabic: "ت نوڤوت",
  },
  {
    city_name: "תעוז",
    city_name_arabic: "تعوز",
  },
  {
    city_name: "תפרח",
    city_name_arabic: "ت فراح",
  },
  {
    city_name: "תקומה",
    city_name_arabic: "كوما",
  },
  {
    city_name: "תקוע",
    city_name_arabic: "ت كو َوع",
  },
  {
    city_name: "תראבין א-צאנע (שבט)",
    city_name_arabic: "ترابين الصانع",
  },
  {
    city_name: "תראבין א-צאנע(ישוב)",
    city_name_arabic: "ترابين الصانع",
  },
  {
    city_name: "תרום",
    city_name_arabic: "تروم",
  },
];

const getCitiesDB = () => {
  let cities_arr = [];
  for (const elem of cities) {
    cities_arr.push(elem[`city_name${getLSLanguage() === "ar" ? "_arabic" : ""}`])
    // cities_arr.push(elem[`city_name`])
  };
  return cities_arr;
}
//*shouldent be commented
export default getCitiesDB;

//! only uncomment if want to generate data
// module.exports = { cities_arr }
